export default {
    title: "AELU",
    ssv: "ວີຊາທັກສະສະເພາະ",
    what_ssv: "ວີຊາທັກສະສະເພາະ",
    representative_message: "ຂໍ້ຄວາມຕາງ ໜ້າ",
    aeru_feature: "ຄຸນລັກສະນະຂອງ AELU",
    aeru_how_to_use: "ກະແສການ ນຳ ໃຊ້",
    aeru_q_a: "ຖາມແລະຕອບ",
    aeru_function: "ຟັງຊັນຂອງ AELU",
    aeru_fee: "ຄ່າບໍລິການ AELU",
    login: "ເຂົ້າ​ສູ່​ລະ​ບົບ",
    db_top_comment1: "ທຳ ອິດໃນອຸດສະຫະ ກຳ! ເວັບໄຊທ໌ຝຶກອົບຮົມກ່ຽວກັບໂທລະສັບສະມາດໂຟນ ສຳ ລັບ ການສອບເສັງວີຊາສະເພາະທີ່ມີສີມືພິເສດ.",
    db_top_comment2: "AELU ແມ່ນບໍລິການເວັບທີ່ສະ ໜັບ ສະ ໜູນ ການໄດ້ຮັບວີຊາທັກສະສະເພາະໂດຍການສຶກສາການສອບເສັງ, ຂໍ້ມູນການສອບເສັງ, ແລະອົງການການສະ ໝັກ.",
    db_top_pr: "ໃຊ້ວີຊາທັກສະສະເພາະຂອງທ່ານເພື່ອຍຶດເອົາໂອກາດ ໃໝ່ໆ.",
    member_regist: "ການລົງທະບຽນສະມາຊິກ",
    registration_support_organization: "ອົງການສະ ໜັບ ສະ ໜູນ ການລົງທະບຽນແມ່ນຫຍັງ?",
    rso_dec1: "ມີສອງອົງກອນໃນລະບົບທັກສະສະເພາະ, ອົງການທີ່ກ່ຽວຂ້ອງກັບທັກສະສະເພາະແລະອົງການສະ ໜັບ ສະ ໜູນ ການລົງທະບຽນ. ອົງກອນທີ່ມີທັກສະສະເພາະແມ່ນບໍລິສັດ (ຍອມຮັບອົງກອນ) ທີ່ຈ້າງຄົນຕ່າງປະເທດທີ່ມີທັກສະສະເພາະ. ສະຖາບັນທີ່ມີທັກສະສະເພາະແມ່ນຕ້ອງໃຫ້ການສະ ໜັບ ສະ ໜູນ ແກ່ຄົນຕ່າງປະເທດທີ່ມີທັກສະສະເພາະໃນບ່ອນເຮັດວຽກ, ຊີວິດປະ ຈຳ ວັນແລະສັງຄົມ.",
    rso_dec2: "ເນື່ອງຈາກມີເນື້ອໃນທີ່ຊ່ຽວຊານສະ ໜັບ ສະ ໜູນ ຄົນຕ່າງປະເທດທີ່ມີທັກສະສະເພາະ, ມີບາງກໍລະນີທີ່ມັນຍາກ ສຳ ລັບບໍລິສັດທີ່ຈ້າງຄົນຕ່າງປະເທດທີ່ມີທັກສະສະເພາະ, ສະຖາບັນທີ່ມີທັກສະສະເພາະນັ້ນ, ເພື່ອສະ ໜັບ ສະ ໜູນ. ອົງການສະ ໜັບ ສະ ໜູນ ການລົງທະບຽນແມ່ນອົງກອນທີ່ຖືກມອບ ໝາຍ ໃຫ້ອົງການທີ່ກ່ຽວຂ້ອງກັບທັກສະສະເພາະເພື່ອສ້າງແລະຈັດຕັ້ງປະຕິບັດແຜນການສະ ໜັບ ສະ ໜູນ ໃຫ້ຄົນຕ່າງປະເທດທີ່ມີທັກສະສະເພາະ.",
    rso_dec3: "ອົງການສະ ໜັບ ສະ ໜູນ ການລົງທະບຽນແມ່ນອົງກອນທີ່ຖືກມອບ ໝາຍ ໃຫ້ອົງການທີ່ກ່ຽວຂ້ອງກັບທັກສະສະເພາະເພື່ອສ້າງແລະຈັດຕັ້ງປະຕິບັດແຜນການສະ ໜັບ ສະ ໜູນ ໃຫ້ຄົນຕ່າງປະເທດທີ່ມີທັກສະສະເພາະ.",
    rso_dec4: "ອົງການສະ ໜັບ ສະ ໜູນ ການລົງທະບຽນຈະໃຫ້ການສະ ໜັບ ສະ ໜູນ ທັງ ໝົດ ໂດຍອີງໃສ່ແຜນການສະ ໜັບ ສະ ໜູນ ຄົນຕ່າງດ້າວທີ່ມີຄວາມ ຊຳ ນິ ຊຳ ນານອັນດັບ 1 ໂດຍຜ່ານສັນຍາການສະ ໜັບ ສະ ໜູນ ກັບອົງການເຈົ້າພາບ.",
    rso_dec5: "○ເພື່ອຈະກາຍເປັນອົງການສະ ໜັບ ສະ ໜູນ ການລົງທະບຽນ, ທ່ານ ຈຳ ເປັນຕ້ອງໄດ້ລົງທະບຽນໂດຍ ກຳ ມະການຂອງ ສຳ ນັກງານກວດຄົນເຂົ້າເມືອງຍີ່ປຸ່ນ.",
    rso_dec6: "ສະຖາບັນທີ່ລົງທະບຽນຈະລົງທະບຽນຢູ່ໃນອົງກອນສະ ໜັບ ສະ ໜູນ ການລົງທະບຽນແລະຈະຖືກລົງໃນເວັບໄຊທ໌ ສຳ ນັກງານກວດຄົນເຂົ້າເມືອງຍີ່ປຸ່ນ.",
    rso_dec7: "ໄລຍະການລົງທະບຽນແມ່ນ 5 ປີແລະຕ້ອງການທີ່ຈະຕໍ່ອາຍຸ.",
    rso_dec8: "organizations ອົງການສະ ໜັບ ສະ ໜູນ ການລົງທະບຽນແມ່ນຕ້ອງໄດ້ສົ່ງແຈ້ງການຕ່າງໆໄປຍັງຫ້ອງການກວດຄົນເຂົ້າເມືອງຂອງປະເທດຍີ່ປຸ່ນໃນທຸກເວລາ.",
    article1: "ວີຊາທັກສະສະເພາະແມ່ນຫຍັງ?",
    article1_dec1: "ດ້ວຍການປະກາດໃຊ້ກົດ ໝາຍ ວ່າດ້ວຍການຄວບຄຸມຄົນເຂົ້າເມືອງສະບັບປັບປຸງ ໃໝ່ ໃນວັນທີ 8 ທັນວາ 2018, ສະຖານະພາບທີ່ຢູ່ອາໄສສະເພາະໄດ້ຮັບການສ້າງຕັ້ງ ໃໝ່. ບັງຄັບໃຊ້ໃນເດືອນເມສາ 2019.",
    article1_dec2: "ສະຖານະພາບ ໃໝ່ ຂອງທີ່ຢູ່ອາໄສທັກສະສະເພາະຈະຖືກສ້າງຕັ້ງຂື້ນເປັນສອງໄລຍະ. (ເບີ 1 ແລະອັນດັບ 2)",
    article1_dec3: "ອຸດສາຫະ ກຳ ເປົ້າ ໝາຍ ແມ່ນ 14 ອຸດສາຫະ ກຳ.,",
    article1_dec4: "ຄວາມຕ້ອງການຄົນຕ່າງປະເທດເປົ້າ ໝາຍ ແມ່ນບຸກຄົນທີ່ມີທັກສະທີ່ຕ້ອງການຄວາມຮູ້ຫຼືປະສົບການຫຼາຍ. ເວົ້າອີກຢ່າງ ໜຶ່ງ, ຜູ້ທີ່ໄດ້ ສຳ ເລັດການຝຶກອົບຮົມດ້ານເຕັກນິກ 3 ປີຫລືຜູ້ທີ່ຜ່ານການສອບເສັງພາສາຍີ່ປຸ່ນແລະຄວາມສາມາດທຽບເທົ່າເທົ່າທຽມກັນແມ່ນມີສິດໄດ້ຮັບ.",
    article1_dec5: "ທັກສະສະເພາະອັນດັບ 1 ແມ່ນອະນຸຍາດໃຫ້ຢູ່ໄດ້ເຖິງ 5 ປີໃນຖານະເປັນຄົນທີ່ມີທັກສະສະເພາະ. ສະມາຊິກໃນຄອບຄົວບໍ່ໄດ້ຮັບອະນຸຍາດ.",
    article1_dec6: "ໃນຖານະເປັນບຸກຄົນທີ່ມີທັກສະ, ທັກສະສະເພາະອັນດັບ 2 ແມ່ນໄດ້ຮັບສະຖານະພາບທີ່ຢູ່ອາໄສທຽບເທົ່າກັບການຈ້າງງານທົ່ວໄປໂດຍການຜ່ານການສອບເສັງພິເສດໃນຊ່ວງໄລຍະສະເພາະຂອງສີມືແຮງງານສະບັບເລກທີ 1. \n (ໂດຍການຕໍ່ອາຍຸການພັກເຊົາ, ທ່ານສາມາດຢູ່ໄດ້ ຖາວອນແລະທ່ານສາມາດພາຄອບຄົວຂອງທ່ານໄປ ນຳ.),",
    article2: "ຂໍ້ຄວາມຕາງ ໜ້າ",
    article2_sub1: "ຢ່າປ່ອຍປະເທດຍີ່ປຸ່ນເທື່ອ",
    article2_dec1: "ພວກເຮົາຂໍສະແດງຄວາມຮູ້ບຸນຄຸນຢ່າງຈິງໃຈຕໍ່ບັນດານັກຝຶກຫັດດ້ານວິຊາການແລະນັກ ສຳ ມະນາກອນທີ່ກັບມາທີ່ປະເທດຍີ່ປຸ່ນເປັນຜູ້ຝຶກຫັດດ້ານວິຊາການ, ໄດ້ຮັບທັກສະ, ແລະບໍ່ມີຄວາມພະຍາຍາມຫຍັງຕໍ່ການພັດທະນາປະເທດຂອງພວກເຂົາ. ຂ້ອຍຄິດວ່າຮູບລັກສະນະຂອງການປະຕິບັດເພື່ອຜົນປະໂຫຍດຂອງຄອບຄົວແລະ ສຳ ລັບປະເທດບ້ານ, ເຊິ່ງບໍ່ແມ່ນຢູ່ປະເທດຍີ່ປຸ່ນໃນປະຈຸບັນ, ແມ່ນລັກສະນະຂອງມະນຸດເດີມ. ໃນຂະນະທີ່ຂ້ອຍໄດ້ເຂົ້າເຮັດທຸລະກິດຝຶກອົບຮົມດ້ານວິຊາການເປັນເວລາດົນນານ, ບໍ່ມີທາງທີ່ຈະເຂົ້າປະເທດພຽງແຕ່ມີວີຊານັກຝຶກອົບຮົມດ້ານວິຊາການ, ແລະຂ້ອຍໄດ້ໃຊ້ໂອກາດນັ້ນ, ຝຶກຢູ່ຍີ່ປຸ່ນຢ່າງ ແໜ້ນ ແຟ້ນ, ເປີດທຸລະກິດໃນຕົວຂ້ອຍ ປະເທດຂອງຕົນເອງ, ແລະປະເທດຂອງຂ້ອຍ ກຳ ລັງພັດທະນາຢ່າງຫຼວງຫຼາຍຂ້ອຍເຫັນຫຼາຍ. ເຖິງຢ່າງໃດກໍ່ຕາມ, ໃນເດືອນເມສາ 2019, ວີຊາສະເພາະສີມືແຮງງານໄດ້ຖືກສ້າງຂຶ້ນ, ເຊິ່ງຕອບສະ ໜອງ ຄວາມປາຖະ ໜາ ທີ່ຈະເພີດເພີນກັບຍີ່ປຸ່ນ, ເຊິ່ງບໍ່ສາມາດຮຽນຮູ້ໄດ້ຢ່າງຄົບຖ້ວນຕາມ ຈຳ ນວນປີທີ່ໄດ້ ກຳ ນົດໄວ້. ຂ້າພະເຈົ້າຫວັງວ່າຊາວຕ່າງປະເທດຫຼາຍຄົນທີ່ມາຢ້ຽມຢາມຍີ່ປຸ່ນທີ່ມີຄວາມທະເຍີທະຍານຢູ່ເບື້ອງຫຼັງສາຍຕາຂອງພວກເຂົາ, ເຊິ່ງເປັນສິ່ງທີ່ຫາຍາກໃນປະເທດຍີ່ປຸ່ນ, ສາມາດພັດທະນາຍີ່ປຸ່ນຮ່ວມກັນ. ສຳ ຄັນທີ່ສຸດ, ຂ້ອຍຢາກມີຄົນຄືຍີ່ປຸ່ນ, ເພີ່ມ ຈຳ ນວນຜູ້ຢູ່ອາໄສຖາວອນ, ແລະສ້າງສັງຄົມທີ່ເຂົາເຈົ້າສາມາດຢູ່ ນຳ ກັນໄດ້.",
    article2_dec2: "ບໍລິສັດສາຍຕາ ຈຳ ກັດ.",
    article2_dec3: "ປະທານແລະຊີອີໂອ",
    article2_dec4: "ຄາຊຸໂກະຮະຮີກີ",
    article3: "ສາມລັກສະນະທີ່ສະ ໜອງ ໂດຍ AELU",
    article3_sub1: "ສຶກສາ ສຳ ລັບການສອບເສັງ online",
    article3_sub1_dec1: "AELU, ເຊິ່ງຊ່ວຍໃຫ້ທ່ານກຽມຕົວ ສຳ ລັບການທົດສອບຄວາມສາມາດສະເພາະໃນໂທລະສັບສະຫຼາດຂອງທ່ານ, ກຽມ ຄຳ ຖາມກ່ຽວກັບ ຄຳ ຖາມຫລັງຈາກ 30 ຄຳ ຖາມໃນ 14 ອຸດສາຫະ ກຳ ທັງ ໝົດ, ລວມທັງ ຄຳ ຖາມທີ່ຜ່ານມາ, ແລະທ່ານສາມາດໃຊ້ມາດຕະການຫຼາຍເທົ່າທີ່ທ່ານຕ້ອງການຮອດວັນສອບເສັງ. ຖ້າທ່ານເກີນຄະແນນທີ່ລະບຸໄວ້ ສຳ ລັບ ຄຳ ຖາມທີ່ຖືກຄົ້ນຫາໂດຍ AI, ທ່ານຈະຕ້ອງຜ່ານການສອບເສັງແນ່ນອນ!",
    article3_sub2: "ຂໍ້ມູນການສອບເສັງ",
    article3_sub2_dec1: "ຂໍ້ມູນການທົດສອບທີ່ມີຄວາມຫຍຸ້ງຍາກຫຼາຍ ສຳ ລັບນັກທ່ອງທ່ຽວຕ່າງປະເທດທີ່ເຂົ້າມາທ່ອງທ່ຽວໃນປະເທດຍີ່ປຸ່ນເຂົ້າໃຈຈະຖືກເພີ່ມໂດຍອັດຕະໂນມັດເມື່ອຂໍ້ມູນການທົດສອບຂອງອຸດສາຫະ ກຳ ທີ່ເລືອກໄດ້ຖືກປັບປຸງຫຼັງຈາກລົງທະບຽນແລ້ວຜູ້ໃຊ້ຈະໄດ້ຮັບການແຈ້ງເຕືອນ",
    article3_sub3: "ຕົວແທນການສະ ໝັກ ສອບເສັງ",
    article3_sub3_dec1: "ເຊັ່ນດຽວກັບຂໍ້ມູນການສອບເສັງ, ມັນເປັນການຍາກຫຼາຍ ສຳ ລັບນັກທ່ອງທ່ຽວຕ່າງປະເທດທີ່ຈະໄປສະ ໝັກ ຢູ່ປະເທດຍີ່ປຸ່ນໃນການສະ ໝັກ ສອບເສັງ, ແລະທ່ານຍັງບໍ່ສາມາດສອບເສັງໄດ້ໂດຍບໍ່ຕ້ອງເຮັດຂັ້ນຕອນ online. ເມື່ອທ່ານລົງທະບຽນ, ທ່ານສາມາດປະກາດຂໍ້ມູນ, ມີແບບຟອມສະ ໝັກ ແລ້ວ, ແລະສະ ໝັກ ໃນເວລາດຽວກັນກັບການປະກາດທົດສອບ.",
    article4: "ການແນະ ນຳ ກ່ຽວກັບ ໜ້າ ທີ່ຫຼັງຈາກຜ່ານການທົດສອບ",
    article4_sub1: "ຂໍສະແດງຄວາມຍິນດີກັບຜູ້ສະ ໝັກ ທີ່ປະສົບຜົນ ສຳ ເລັດ \n ເງິນສົດກັບມາ (ພາຍໃນແລະຕ່າງປະເທດ)",
    article4_sub1_dec1: "ຖ້າທ່ານອາໃສຢູ່ປະເທດຍີ່ປຸ່ນຢູ່ແລ້ວແລະຜ່ານການ ນຳ ໃຊ້ AELU ແລ້ວອັບໂຫລດເລກທີແລະໃບຢັ້ງຢືນຜ່ານ ໜ້າ ຈໍຜູ້ໃຊ້ຂອງທ່ານ, ທ່ານສາມາດໄດ້ຮັບເງິນສົດຄືນໃນມື້ດຽວກັນ. ຜະລິດຕະພັນເງິນສົດແບບແຜນຄືນ ໃໝ່: ໃບຢັ້ງຢືນຂອງຂວັນອອນໄລນ໌ (ໃບຢັ້ງຢືນ Amazon Gift Email Email) ປະເພດ, Googleplay, iTunes gift card) ເງິນສົດ 5000 ຢວນກັບຈາກບັນຊີທາງການຂອງ LINE.",
    article4_sub2: "ອ້າງອີງເຖິງການໂຄສະນາຫາເພື່ອນ",
    article4_sub2_dec1: "ເຊີນຜູ້ສະ ໝັກ ໄປປະເທດຍີປຸ່ນທີ່ປະເທດຍີ່ປຸ່ນຫລືຕ່າງປະເທດເຂົ້າຮ່ວມກຸ່ມ FB, ຜູ້ໃຊ້ຈະບອກຕົວເລກການຈັດການຂອງຕົວເອງແລະເງິນຄືນໃຫ້ບຸກຄົນທີ່ກ່ຽວຂ້ອງກັບຕົວເລກດັ່ງກ່າວ, ແລະໃບຢັ້ງຢືນຂອງຂວັນ online ຈຳ ນວນ 1000 ໃບຈະຖືກມອບໃຫ້ຜູ້ແນະ ນຳ ເດືອນຫລັງຈາກເຂົ້າຮ່ວມ. ເງິນເຢນກັບຄືນ.",
    article4_sub3: "ຫລັງຈາກໄດ້ຮັບວີຊາແລ້ວ, ການຊອກຫາວຽກແມ່ນ \n ການຈັບຄູ່ອັດຕະໂນມັດ AI (ບໍ່ໄດ້ຕັດສິນໃຈ)",
    article4_sub3_dec1: "ຫລັງຈາກຜ່ານການສອບເສັງໃບຢັ້ງຢືນໂດຍໃຊ້ AELU, ອັບໂຫລດໃບຜ່ານງານແລະໃບຢັ້ງຢືນຜ່ານໃນ ໜ້າ ຈໍຜູ້ໃຊ້, ແລະທ່ານຈະໄດ້ຮັບໃບສະ ເໜີ ອັດຕະໂນມັດຈາກບໍລິສັດທັງ ໝົດ ໃນປະເທດຍີ່ປຸ່ນ. ການ ສຳ ພາດຍັງຈະຖືກ ດຳ ເນີນຢູ່ທາງອິນເຕີເນັດ, ແລະທ່ານຈະສາມາດເຂົ້າໄປໃນປະເທດ, ຍ້າຍອອກໄປ, ແລະໄດ້ວຽກທີ່ມີຄວາມສະຫງົບສຸກໂດຍການເຊື່ອມຕໍ່ທາງອິນເຕີເນັດເຖິງແມ່ນວ່າໃນບົດຂຽນເບື້ອງຕົ້ນ!",
    article4_sub4: "ກວດກາບັດປະ ຈຳ ຢູ່ປົກກະຕິ \n ເງິນສົດຄືນ (ບໍ່ໄດ້ຕັດສິນໃຈ),",
    article4_sub4_dec1: "ຖ້າທ່ານກວດບັດທີ່ຢູ່ອາໄສຂອງທ່ານ ໜຶ່ງ ຄັ້ງຕໍ່ເດືອນໂດຍບໍ່ມີບັດໃນບັດກວດທີ່ຢູ່ອາໄສ One Check Tab, ທ່ານຈະໄດ້ຮັບເງິນສົດ 10,000 ເຢນຄືນໃນ ໜຶ່ງ ປີ,,",
    article5: "ການແນະ ນຳ ກ່ຽວກັບ ໜ້າ ທີ່ສະເພາະ,",
    article5_sub1: "ທ່ານສາມາດເບິ່ງຄືນບັນຫາທີ່ທ່ານໄດ້ແກ້ໄຂ",
    article5_sub1_dec1: "ທ່ານສາມາດສະສົມເນື້ອໃນການສອບເສັງທີ່ທ່ານໄດ້ຝຶກອົບຮົມທາງອິນເຕີເນັດແລະໃຊ້ເຄື່ອງມືຂອງທ່ານເອງເພື່ອເຂົ້າໃຈນິໄສຂອງຜູ້ໃຊ້ແລະເອົາຊະນະບັນຫາທີ່ທ່ານບໍ່ເກັ່ງ. ຍ້ອນວ່າທ່ານສາມາດກຽມຕົວໃຫ້ໄດ້ຫຼາຍຄັ້ງຕາມທີ່ທ່ານຕ້ອງການ, ບັນທຶກປະຫວັດຄະແນນທັງ ໝົດ ແລະເວລາສອບເສັງ, ແລະເຮັດໃຫ້ມັນໃກ້ທີ່ສຸດເທົ່າທີ່ຈະເປັນໄປໄດ້ໃນມື້ທົດສອບຕົວຈິງ. ນອກຈາກນັ້ນ, ທ່ານຍັງສາມາດເຂົ້າໃຈ ຄຳ ຖາມໄດ້ດີຂື້ນເພາະມັນຖືກຂຽນເປັນທັງພາສາຂອງທ່ານເອງແລະພາສາຍີ່ປຸ່ນ.",
    article5_sub2: "ບັນທຶກຊີວະປະຫວັດຂອງທ່ານຢ່າງຖາວອນໃນເວລາເຂົ້າ",
    article5_sub2_dec1: "ເມື່ອທ່ານສອບເສັງວີຊາທັກສະສະເພາະແລະຍື່ນຂໍວີຊາ, ທ່ານຈະຕ້ອງມີຊີວະປະຫວັດເມື່ອທ່ານເຂົ້າປະເທດຍີ່ປຸ່ນເປັນນັກຝຶກຫັດດ້ານວິຊາການ. ໃນເບື້ອງຕົ້ນຖືກຈັດເກັບໂດຍອົງການຄຸ້ມຄອງ (ສະຫະກອນ) ຫຼືອົງການຈັດຕັ້ງສົ່ງ, ທ່ານສາມາດເກັບມັນໄວ້ໂດຍຕົວທ່ານເອງຫຼັງຈາກໄດ້ຮັບວີຊາທັກສະສະເພາະ.",
    article5_sub3: "ໜ້າ ທີ່ລົງທະບຽນຂອງປະເທດແລະສະ ໜາມ ຂອງທ່ານ,",
    article5_sub3_dec1: "ເນື່ອງຈາກພາສາຂອງປະເທດຂອງທ່ານເອງແລະຍີ່ປຸ່ນຖືກ ນຳ ໃຊ້ຮ່ວມກັນ, ທ່ານສາມາດເຂົ້າໃຈ ຄຳ ຖາມຕ່າງໆໄດ້ເປັນຢ່າງດີແລະໃຊ້ມາດຕະການຕອບໂຕ້ຕ່າງໆ. ໃນການສອບເສັງເດີມມີພຽງແຕ່ພາສາຍີ່ປຸ່ນເທົ່ານັ້ນ, ສະນັ້ນທ່ານສາມາດໃຊ້ມາດຕະການເປັນພາສາຍີ່ປຸ່ນເທົ່ານັ້ນ,,",
    article5_sub4: "ການແຈ້ງເຕືອນກ່ຽວກັບຂໍ້ ກຳ ນົດການສອບເສັງໃບຢັ້ງຢືນແລະຂໍ້ມູນ",
    article5_sub4_dec1: "ເມື່ອຕາຕະລາງການທົດສອບ ສຳ ລັບອາຊີບທີ່ຕ້ອງການຈະຖືກອັບໂຫລດໃສ່ HP ໂດຍແຕ່ລະກຸ່ມທົດສອບ, ມັນຈະຖືກເຕືອນໂດຍອັດຕະໂນມັດ, ຜູ້ໃຊ້ຈະໄດ້ຮັບການແຈ້ງເຕືອນ, ວັນທີທົດສອບຈະຖືກ ກຳ ນົດຢູ່ ໜ້າ ຈໍຜູ້ໃຊ້, ແລະເຄື່ອງຈັບເວລາຈະເຮັດວຽກໂດຍອັດຕະໂນມັດ.",
    article5_sub5: "ການຮຽນຮູ້ໂດຍໃຊ້ການກວດສອບ",
    article5_sub5_dec1: "ທ່ານສາມາດສະກັດຈຸດອ່ອນຂອງຜູ້ໃຊ້ແລະກຽມຕົວເຂົ້າໃນການສອບເສັງ.",
    article5_sub6: "ໃຫ້ ຄຳ ປຶກສາດ້ານການຮຽນຮູ້ແລະການ ສຳ ພາດໂດຍໃຊ້ກ້ອງຖ່າຍຮູບໂທລະສັບສະຫຼາດ.",
    article5_sub6_dec1: "ໃນຂະນະທີ່ ດຳ ເນີນການກະກຽມການສອບເສັງໂດຍໃຊ້ Aer, ທ່ານຈະສາມາດອະທິບາຍຄວາມ ໝາຍ ແລະເຈດຕະນາຂອງ ຄຳ ຖາມໃນຮູບແບບຂອງການໂທແລະການສົນທະນາທາງອິນເຕີເນັດ. ມັນອາດຈະບໍ່ ຈຳ ເປັນ ສຳ ລັບຜູ້ທີ່ຄຸ້ນເຄີຍກັບຍີ່ປຸ່ນຫຼືຜູ້ທີ່ຄຸ້ນເຄີຍກັບມັນ, ແຕ່ວ່າການໃຫ້ບໍລິການປຶກສາດ້ານການໂທຫາຂັ້ນພື້ນຖານແມ່ນວິທີທີ່ ໝັ້ນ ໃຈທີ່ສຸດໃນການກວດສອບຄວາມກັງວົນຕ່າງໆກ່ອນການສອບເສັງ!",
    article6: "ຄ່າ ທຳ ນຽມ",
    article6_sub1: "ຄ່າ ທຳ ນຽມການ ນຳ ໃຊ້ຂອງ AELU",
    article6_sub1_dec1: "ທ່ານສາມາດຮຽນ ສຳ ລັບການສອບເສັງວີຊາທັກສະສະເພາະໂດຍບໍ່ ຈຳ ກັດ. ທ່ານສາມາດປຶກສາທາງອິນເຕີເນັດເປັນພາສາ ກຳ ເນີດຂອງທ່ານ. * ທ່ານຍັງສາມາດໃຊ້ມັນເປັນນາຍແປພາສາໃນເວລາ ທຳ ມະດາ. \n ປະກາດຫາສະຖານທີ່ສອບເສັງແມ່ນເປັນໄປໄດ້ໃນມື້ສອບເສັງ. \n ສືບຕໍ່ການເຂົ້າປະເທດສາມາດບັນທຶກຕະຫຼອດໄປ. \n ຫລັງຈາກຜ່ານການສອບເສັງ, ພຽງແຕ່ລົງທະບຽນເລກບັດວີຊາທັກສະສະເພາະຂອງທ່ານເພື່ອແນະ ນຳ ວຽກທີ່ທ່ານຕ້ອງການ. (ບໍ່ໄດ້ຕັດສິນໃຈ).",
    article6_sub2: "ຕົວແທນການສະ ໝັກ ສອບເສັງ",
    article6_sub2_dec1: "ທ່ານບໍ່ສາມາດສະ ໝັກ ໃນເວລາເຮັດວຽກໄດ້, ແລະທ່ານຈະບໍ່ສາມາດສອບເສັງໃບຢັ້ງຢືນເວັ້ນເສຍແຕ່ວ່າທ່ານສະ ໝັກ, ສະນັ້ນພວກເຮົາຈະສະ ໝັກ ທັນທີເມື່ອຂໍ້ມູນການສອບເສັງມີເພື່ອທ່ານຈະບໍ່ພາດວັນສອບເສັງ.",
    article7: "ຂະບວນການ Cashback ກຳ ລັງ ດຳ ເນີນການ!",
    article7_dec1: "ຈາກຜູ້ທີ່ຜ່ານການສອບເສັງ, ຜູ້ທີ່ລົງທະບຽນເລກວີຊ່າ ສຳ ລັບບໍລິການນີ້ຈະໄດ້ຮັບເງີນຄືນ 5,000 \n ເຢນ! ກົດບ່ອນນີ້ ສຳ ລັບວິທີການເຂົ້າຮ່ວມໃນການໂຄສະນາ.",
    article8: "ດຽວນີ້ສາມາດລົງທະບຽນກັບ AELU!",
    dashboard: "ແຜງຄວບຄຸມ",
    member_info: "ການລົງທະບຽນຂໍ້ມູນໂປຣໄຟລ໌",
    first_name: "ຊື່",
    midle_name: "ຊື່​ກາງ",
    family_name: "ນາມສະກຸນ",
    half_width_Roman: "Romaji ເຄິ່ງຄວາມກວ້າງ",
    password: "ລະຫັດຜ່ານ",
    password_confirm: "ການຢືນຢັນລະຫັດຜ່ານ",
    mail_adress: "ທີ່ຢູ່ເມລ",
    lineId: "ໝາຍ ເລກເສັ້ນ",
    country_id: "ລະ​ຫັດ​ປະ​ເທດ",
    phone: "ເບີ​ໂທລະ​ສັບ",
    issuing_country: "ເລືອກປະເທດ / ພາກພື້ນຂອງການອອກບັດປະ ຈຳ ຕົວ",
    IDtype: "ການເລືອກປະເພດ ID",
    residence_card: "ບັດປະ ຈຳ ຕົວຫລືບັດປະ ຈຳ ຕົວ",
    passport: "ໜັງ ສືເດີນທາງ",
    regist: "ການລົງທະບຽນ",
    is_required: "ແມ່ນບັງຄັບ",
    sign_up: "ລົງ​ທະ​ບຽນ",
    residence_front: "ການອັບໂຫລດ ໜ້າ ດິນ",
    residence_back: "ອັບໂຫລດຢູ່ດ້ານຫຼັງ",
    passport_upload: "ອັບໂຫລດ ໜັງ ສືເດີນທາງຂອງທ່ານ",
    error_file: "ກະລຸນາອັບໂຫລດຮູບພາບ",
    post_resume: "ຍື່ນຊີວະປະຫວັດ",
    resume_upload: "ຊີວະປະຫວັດຫຍໍ້",
    click_upload: "ກົດເພື່ອອັບໂຫລດ",
    image_drop: "ຫຼືລາກແລະວາງແຟ້ມຮູບພາບ",
    select_language: "ທາງເລືອກຂອງພາສາແມ່",
    vietnamese: "ຫວຽດນາມ",
    chinese: "ຈີນ",
    english: "ພາສາອັງກິດ",
    khmer: "ພາສາລາວ",
    indonesian: "ອິນໂດເນເຊຍ",
    tagalog: "ຕາກາລTagalogອກ",
    burmese: "ມຽນມາ",
    hindu: "ຮິນດູ",
    lao: "ລາວ",
    mongolian: "ພາສາມົງໂກນ",
    bengali: "ພາສາເບັງກາລີ",
    sinhala: "ສິນລະປະ",
    banglodesh: "ບັງກະລາເທດ",
    malay: "ມາເລ",
    nepali: "ເນປານ",
    thai: "ໄທ",
    japanese: "ຍີ່ປຸ່ນ",
    error_lang: "ກະລຸນາເລືອກພາສາ ກຳ ເນີດຂອງທ່ານ.",
    select_ouccupation: "ການຄັດເລືອກປະເພດວຽກ",
    select_max_three: "ທ່ານສາມາດເລືອກໄດ້ເຖິງສາມ.",
    industry_id_1: "ອຸດສາຫະ ກຳ ເບິ່ງແຍງໄລຍະຍາວ",
    industry_id_2: "ທຸລະກິດເຮັດຄວາມສະອາດອາຄານ",
    industry_id_3: "ອຸດສາຫະ ກຳ ວັດຖຸດິບ",
    industry_id_4: "ອຸດສາຫະ ກຳ ຜະລິດເຄື່ອງຈັກອຸດສາຫະ ກຳ",
    industry_id_5: "ອຸດສາຫະ ກຳ ທີ່ກ່ຽວຂ້ອງກັບຂໍ້ມູນໄຟຟ້າແລະເອເລັກໂຕຣນິກ",
    industry_id_6: "ອຸດສາຫະ ກຳ ການກໍ່ສ້າງ",
    industry_id_7: "ອຸດສາຫະ ກຳ ການຂົນສົ່ງ / ເຮືອທະເລ",
    industry_id_8: "ອຸດສາຫະ ກຳ ບຳ ລຸງຮັກສາລົດ",
    industry_id_9: "ອຸດສາຫະ ກຳ ການບິນ",
    industry_id_10: "ທຸລະກິດທີ່ພັກອາໃສ",
    industry_id_11: "ກະສິ ກຳ",
    industry_id_12: "ການປະມົງ",
    industry_id_13: "ການຜະລິດອາຫານແລະເຄື່ອງດື່ມ",
    industry_id_14: "ທຸລະກິດຮ້ານອາຫານ",
    industry: "ອຸດສາຫະ ກຳ",
    error_occupation: "ກະລຸນາເລືອກປະເພດວຽກ ໜຶ່ງ ຫຼືຫຼາຍກວ່ານັ້ນ.",
    do: "ເພື່ອເຮັດ",
    news_tpic: "ຂ່າວ",
    days_until_exam: "ມື້ທີ່ເຫຼືອຈົນກ່ວາການສອບເສັງ",
    estimated_pass_rate: "ອັດຕາການຜ່ານທີ່ຄາດຄະເນ",
    average_score_taken: "ຄະແນນສະເລ່ຍຂອງການທົດສອບທີ່ຖືກປະຕິບັດ",
    exam: "ການສອບເສັງແມ່ນ",
    let_aim: "ສາມາດເຮັດໃຫ້ຈຸດປະສົງ",
    score: "ຈຸດ",
    solve_problem: "ແກ້ໄຂ ຄຳ ຖາມ",
    recommend_problem: "AELUs ແນະ ນຳ ຄຳ ຖາມ",
    solved_problem: "ຄຳ ຖາມທີ່ແກ້ໄຂໃນອະດີດ",
    looking_solved: "ກວດສອບ ຄຳ ຖາມທີ່ຜ່ານມາ",
    consultaion_service: "ບໍລິການໃຫ້ ຄຳ ປຶກສາຮຽນຮູ້",
    application_agency: "ບໍລິການຕົວແທນການສອບເສັງ",
    billing: "ໃບບິນ",
    more_look: "ກວດເບິ່ງເພີ່ມເຕີມ",
    more_look2: "ກວດເບິ່ງເພີ່ມເຕີມ",
    facebook: "ເຟສບຸກ",
    google: "Google",
    until_not_account: "ຖ້າທ່ານຍັງບໍ່ມີບັນຊີເທື່ອ",
    or: "ຫຼື",
    other_way: "ໃນທາງອື່ນ",
    not_have_account: "ຖ້າທ່ານບໍ່ມີບັນຊີ",
    have_account: "ຖ້າທ່ານມີບັນຊີ",
    forgot_password: "ຖ້າທ່ານລືມລະຫັດຜ່ານຂອງທ່ານແລ້ວ",
    this: "ທີ່ນີ້",
    at_login: "ເຂົ້າສູ່ລະບົບກັບ",
    pass_condition: "8 ໂຕອັກສອນຫຼືຕົວ ໜັງ ສືຕົວ ໜັງ ສືໂຕະນ້ອຍທີ່ມີຕົວ ໜັງ ສືດຽວ",
    at_sign_up: "ລົງທະບຽນ ໃໝ່ ກັບ",
    agreement1: "ໂດຍການຕົກລົງເຫັນດີຕໍ່ໄປນີ້ແລະເລືອກທີ່ຈະສືບຕໍ່, AELU",
    terms: "ເງື່ອນໄຂການໃຫ້ບໍລິການ",
    agreement2: "ຂ້ອຍ​ເຫັນ​ດີ​ກັບ​ເຈົ້າ.",
    agree: "ຕົກລົງເຫັນດີແລະ ດຳ ເນີນຕໍ່ໄປ",
    account_confirm: "ລະ​ຫັດ​ຢືນ​ຢັນ",
    confirm: "ການຢັ້ງຢືນ",
    not_confirm: "ລະຫັດຢືນຢັນບໍ່ໄດ້ຮັບການຢືນຢັນ.",
    move_confiirm: "ຍ້າຍໄປ ໜ້າ ຈໍປ້ອນລະຫັດຢືນຢັນ",
    top: "ທາງເທີງ",
    news_list: "ບັນຊີຂ່າວ",
    problim_list: "ບັນຊີລາຍຊື່ ຄຳ ຖາມ",
    learning_consul: "ການປຶກສາຫາລືການຮຽນຮູ້",
    agency: "ຂໍ້ມູນການສອບເສັງ",
    of_trend: "ກ່ຽວກັບແນວໂນ້ມຂອງການທົດສອບ",
    start_test: "ເລີ່ມຕົ້ນການທົດສອບ",
    study_mode: "ຮູບແບບການຮຽນຮູ້",
    order_question: "ຄຳ ຖາມ",
    of_question: "ໃນ ຄຳ ຖາມ",
    question_current: "ຄຳ ຖາມທີ່ຕອບຖືກ",
    to_mypage: "ກັບຫນ້າຂອງຂ້ອຍ",
    correct_answer: "ຄຳ ຕອບຖືກຕ້ອງ!",
    correct_answer_normal: "ຄຳ ຕອບທີ່ຖືກຕ້ອງ",
    no_correct_answer: "ຄຳ ຕອບທີ່ບໍ່ຖືກຕ້ອງ",
    next: "ຕໍ່ ຄຳ ຖາມຕໍ່ໄປ",
    finish_all: "ຕອບທຸກ ຄຳ ຖາມ!",
    your_score: "ຄະແນນຂອງທ່ານແມ່ນ",
    is: "ແມ່ນ!",
    result_description: "ທ່ານສາມາດແກ້ໄຂ ຄຳ ຖາມອື່ນໆຈາກລາຍການເບິ່ງ ຄຳ ຖາມ. ທ່ານຍັງສາມາດເບິ່ງຄືນ ຄຳ ຖາມທີ່ທ່ານໄດ້ແກ້ໄຂໃນອະດີດຈາກ ໜ້າ ລາຍການ ຄຳ ຖາມ.",
    back_quiz_list: "ກວດເບິ່ງລາຍຊື່ ຄຳ ຖາມ",
    retry: "ແກ້ໄຂ ຄຳ ຖາມນີ້ອີກຄັ້ງ",
    no_description: "ບໍ່ມີ ຄຳ ອະທິບາຍຫຍັງ",
    show_ans: "ກວດເບິ່ງ ຄຳ ຕອບ",
    of_solved_problem: "ຄຳ ຖາມທີ່ແກ້ໄຂໃນອະດີດ",
    of_solved_problem_list: "ລາຍຊື່ ຄຳ ຖາມທີ່ແກ້ໄຂໃນອະດີດ",
    solved_description: "ທ່ານສາມາດກວດສອບການທົດສອບການຮຽນຮູ້ອີກຄັ້ງ ສຳ ລັບການທົດສອບວີຊາທັກສະສະເພາະຂອງອຸດສາຫະ ກຳ ການດູແລໄລຍະຍາວ.",
    before_result: "ຜົນໄດ້ຮັບທີ່ຜ່ານມາ",
    looking_back: "ກວດເບິ່ງອີກຄັ້ງ",
    back_solved_problem_list: "ກວດເບິ່ງບັນຊີລາຍຊື່ຂອງ ຄຳ ຖາມທີ່ແກ້ໄຂໃນອະດີດ",
    again_retry: "ກຳ ລັງເບິ່ງຄືນ ຄຳ ຖາມນີ້ອີກ",
    done_member_regist: "ຂອບໃຈ ສຳ ລັບການລົງທະບຽນເຂົ້າເປັນສະມາຊິກ!",
    done_member_regist_description: "ແຕ່ລະບໍລິການຈະມີໃຫ້ຫຼັງຈາກທີ່ທ່ານຈ່າຍຄ່າ ທຳ ນຽມການ ນຳ ໃຊ້ບໍລິການ. \n ກະລຸນາລົງທະບຽນຂໍ້ມູນການຈ່າຍເງິນຂອງທ່ານ.",
    choose_payment: "ເລືອກວິທີການຈ່າຍເງິນ",
    service_content: "ເນື້ອໃນບໍລິການ",
    test_info_service: "ບໍລິການຂໍ້ມູນການສອບເສັງ",
    usage_fee: "ຄ່າໃຊ້ຈ່າຍ",
    test_fee: "500 ເຢນ + ພາສີ",
    application_fee: "20000 ເຢນ + ພາສີ",
    method_payment: "ວິທີການຈ່າຍເງິນ",
    LINE_pay: "ເສັ້ນຈ່າຍ",
    line_pay_description: "* ກະລຸນາບັນທຶກຮູບພາບລະຫັດ QR ແລະຈ່າຍເງິນພາຍໃນບໍລິການ LINE Pay. ເມື່ອຈ່າຍເງິນກັບ LINE Pay ມັນຈະຕ້ອງໃຊ້ເວລາເພື່ອໃຫ້ຜູ້ບໍລິຫານຢືນຢັນ.",
    save_qr: "ບັນທຶກລະຫັດ QR",
    next_stage: "ຕໍ່ໄປ",
    credit_card: "ບັດ​ເຄຣ​ດິດ",
    copmplete_payment: "ການຈ່າຍເງິນ ສຳ ເລັດແລ້ວ.",
    copmplete_payment_descript: "ດຽວນີ້ການຈ່າຍເງິນ ສຳ ເລັດແລ້ວ, ທ່ານສາມາດໃຊ້ ໜ້າ ທີ່ສຶກສາການສອບເສັງທາງອິນເຕີເນັດ, ຂໍ້ມູນການສອບເສັງ, ແລະການບໍລິການຂອງອົງການການສອບເສັງ.",
    start_sevice: "ເລີ່ມຕົ້ນໃຊ້ບໍລິການ",
    to_payment: "ເພື່ອ ໜ້າ ຈໍຈ່າຍເງິນ",
    of_news_list: "ບັນຊີຂ່າວ",
    done_payment: "ການ ຊຳ ລະເງິນ ສຳ ເລັດແລ້ວ.",
    tv_consult: "ປຶກສາຫາລື Videophone",
    tell_consult: "ປຶກສາທາງໂທລະສັບ",
    learning_consul_descript01: "ໃບສະ ໝັກ ສອບເສັງ",
    learning_consul_descript02: "ພວກເຮົາຈະເຮັດ ໜ້າ ທີ່ແທນທ່ານ",
    money_unit: "ເຈພີ",
    learning_consul_unit: "ຄັ້ງດຽວ",
    fault_payment1: "ການຈ່າຍເງິນລົ້ມເຫລວ.",
    fault_payment2: "ກະລຸນາລອງ ໃໝ່ ອີກຄັ້ງ.",
    no_examination: "ຍັງ​ເທື່ອ",
    no_exam: "ບໍ່ມີການສອບເສັງເທື່ອ",
    undecided: "ບໍ່ມີການຕັດສິນໃຈ",
    retry_login: "ກະລຸນາເຂົ້າສູ່ລະບົບອີກຄັ້ງ",
    no_problem: "ບໍ່ມີການແກ້ໄຂບັນຫາລະເບີດ",
    do_problem: "ແກ້ໄຂ ຄຳ ຖາມ",
    qa_title: "ຄໍາ​ຖາມ​ທີ່​ຖືກ​ຖາມ​ເລື້ອຍໆ",
    search_category: "ແຄບລົງຕາມ ໝວດ ໝູ່",
    search_freeward: "ຄົ້ນຫາດ້ວຍ ຄຳ ຟຣີ",
    test_result: "ປະຕິບັດຜົນການທົດສອບ",
    to_top: "ເຖິງດ້ານເທິງ",
    missPassword: "ລະຫັດຜ່ານຫຼືທີ່ຢູ່ອີເມວບໍ່ຖືກຕ້ອງ",
    sample_problem: "ມີປະສົບການໃນການຮຽນເພື່ອການສອບເສັງ online",
    exercises: "ອອກ ກຳ ລັງກາຍ",
    let_exercises: "ຂໍໃຫ້ແກ້ໄຂພຽງແຕ່ປັນຫາທີ່ແທ້ຈິງເທົ່ານັ້ນ!",
    to_qa: "ກວດສອບຕື່ມ Q & A",
    read_more: "ກວດເບິ່ງເພີ່ມເຕີມ",
    account_setting: "ການຕັ້ງຄ່າບັນຊີ",
    profile_setting: "ການຕັ້ງຄ່າຂໍ້ມູນ",
    notification_setting: "ການຕັ້ງຄ່າແຈ້ງເຕືອນ",
    logout: "ອອກ​ຈາກ​ລະ​ບົບ",
    changeEmail: "ປ່ຽນທີ່ຢູ່ອີເມວ",
    changePassword: "ປ່ຽນ​ລະ​ຫັດ​ຜ່ານ",
    change: "ປ່ຽນແປງ",
    save: "ປະຢັດ",
    change_success: "ການປ່ຽນແປງ ສຳ ເລັດແລ້ວ",
    now_password: "ລະ​ຫັດ​ປັດ​ຈຸ​ບັນ",
    new_password: "ລະຫັດຜ່ານ ໃໝ່",
    check_new_password: "ລະຫັດລັບ ໃໝ່ (ການຢືນຢັນ)",
    do_logout: "ອອກຈາກລະບົບແລ້ວ",
    done_learning_consul_payment: "ການ ຊຳ ລະເງິນໄດ້ ສຳ ເລັດແລ້ວ.",
    past_exam: "ຄຳ ຖາມທີ່ຜ່ານມາ",
    update_info: "ການປັບປຸງຂໍ້ມູນລ້າສຸດ",
    official_sns: "SNS ຢ່າງເປັນທາງການ",
    privacy_policy: "ນະໂຍບາຍຄວາມເປັນສ່ວນຕົວ",
    terms_service: "ເງື່ອນໄຂການໃຫ້ບໍລິການ",
    transaction_law: "ແຈ້ງການໂດຍອີງໃສ່ກົດ ໝາຍ ວ່າດ້ວຍທຸລະ ກຳ ການຄ້າສະເພາະ",
    selectCountry: "ກະລຸນາເລືອກປະເທດ",
    goInquiry: "ດຳ ເນີນການສອບຖາມ",
    lineInquiry: "ຕິດຕໍ່ພວກເຮົາຜ່ານ LINE",
    regist_accept_certificate: "ການລົງທະບຽນໃບຢັ້ງຢືນການຂໍວີຊາທັກສະສະເພາະ",
    accept_certificate_description: "ທ່ານສາມາດລົງທະບຽນໃບຢັ້ງຢືນຜ່ານແດນແລະເລກທີຂອງທ່ານ",
    accept_certificate: "ໃບຢັ້ງຢືນການຍອມຮັບ",
    accept_number: "ເລກທີ່ຜ່ານ",
    immigration_resume: "ສືບຕໍ່ລົງທະບຽນໃນເວລາເຂົ້າ",
    resendCode: "ສົ່ງລະຫັດຢືນຢັນຄືນ ໃໝ່",
    line_at_register: "ສອບຖາມຂໍ້ມູນການບໍລິການຜ່ານ LINE @",
    study: "ສຶກສາແລະກວດສອບອີກຄັ້ງ",
    study_text: "ດາວໂຫລດຂໍ້ຄວາມການຮຽນຮູ້",
    do_resume_update: "ກະລຸນາອັບຊີວະປະຫວັດຂອງທ່ານ",
    done_resume_update: "ຂອບໃຈ ສຳ ລັບການລົງທະບຽນຊີວະປະຫວັດຂອງທ່ານ!",
    regist_resume_enter: "ການລົງທະບຽນຊີວະປະຫວັດໃນເວລາເຂົ້າ",
    about_company: "ກ່ຽວກັບບໍລິສັດປະຕິບັດງານ",
    add_exam_info_detail: "ຂໍ້ມູນການສອບເສັງໄດ້ຮັບການເພີ່ມ. ກົດບ່ອນນີ້ ສຳ ລັບລາຍລະອຽດແລະການສະ ໝັກ",
    regist_result_get_money: "ລົງທະບຽນຜົນການສອບເສັງຂອງທ່ານແລະໄດ້ເງິນຂອງທ່ານ",
    detail: "ລາຍລະອຽດ",
    about_withdrawal_subsc: "ກ່ຽວກັບການຖອນແລະການຍົກເລີກການສະ ໝັກ ໃຊ້",
    apply_withdrawal: "ຄໍາຮ້ອງສະ ໝັກ ຂໍສະ ໝັກ",
    apply_subsc: "ໃບສະ ໝັກ ເພື່ອສະ ໝັກ ຈາກການສະ ໝັກ ສະມາຊິກ",
    about_withdrawal: "ການຖອນເງິນ",
    about_subsc: "ຍົກເລີກການສະ ໝັກ ສະມາຊິກ",
    exam_info: "ຂໍ້ມູນການສອບເສັງ",
    date: "ວັນທີແລະເວລາ",
    day: "ມື້",
    place: "ສະຖານທີ່",
    result_publication: "ການພິມເຜີຍແຜ່ຜົນ",
    result_publication_place: "ສະຖານທີ່ເພື່ອປະກາດຜົນ",
    result_this_page: "ຈະຖືກປະກາດໃນ ໜ້າ ນີ້",
    exam_way: "ຮູບແບບການສອບເສັງ",
    exam_way2: "ຮູບແບບ ຄຳ ຖາມສອບເສັງ",
    include_exam_fee: "ລວມທັງຄ່າ ທຳ ນຽມການທົດສອບ",
    exam_application_desc: "ການຍື່ນແບບຟອມສະ ໝັກ ເຂົ້າສອບເສັງ. \n ຕິດຕໍ່ພົວພັນກັບຫ້ອງການສອບເສັງ \n ຕິດຕໍ່ສິ່ງທີ່ຕ້ອງກະກຽມພາຍໃນມື້ (LINE @) \n ປຶກສາຫາລືກ່ຽວກັບ ຄຳ ຖາມໃດໆກ່ຽວກັບການສອບ",
    self_application: "ສະ ໝັກ ດ້ວຍຕົວເອງ",
    application_method: "ວິທີການສະ ໝັກ",
    under_this_url: "ກະລຸນາເຮັດ ສຳ ເລັດຂັ້ນຕອນການສະ ໝັກ ຈາກ URL ຕໍ່ໄປນີ້.",
    do_appliction: "ສະ ໝັກ ເຂົ້າສອບເສັງ",
    study_with_aeru: "ນຳ ໃຊ້ ໜ້າ ທີ່ການສຶກສາສອບເສັງຈາກ ໜ້າ ເທິງເພື່ອເພີ່ມອັດຕາການສອບເສັງ.",
    line_at_consul: "ບໍລິການໃຫ້ ຄຳ ປຶກສາຮຽນຮູ້ LINE @",
    instagram: "Instagram",
    do_signup: "ທ່ານໄດ້ຖືກຮັບຮອງ. \n ກະລຸນາເຂົ້າສູ່ລະບົບອີກຄັ້ງ.",
    gender: "ເພດ",
    man: "ຜູ້​ຊາຍ",
    woman: "ເພດຍິງ",
    input_problem_title: "ປະກອບມີຫົວຂໍ້ຂອງບັນຫາ ...",
    still_no_problem: "ບໍ່ມີບັນຫາ",
    enter_in_problem_trend: "ປະກອບມີ ຄຳ ອະທິບາຍສັ້ນໆກ່ຽວກັບການສອບເສັງເຊັ່ນ: ທ່າອ່ຽງຂອງການສອບເສັງຈົນເຖິງປະຈຸບັນແລະຮູບແບບ ຄຳ ຕອບ (ປະເພດການຄັດເລືອກ).",
    correct: "ຄຳ ຕອບທີ່ຖືກຕ້ອງ",
    explanation: "ຄໍາອະທິບາຍ",
    problem: "ຄຳ ຖາມ",
    do_nursing_not_published: "ການສອບເສັງແມ່ນໄດ້ຖືກ ດຳ ເນີນໃນອຸດສະຫະ ກຳ ການດູແລໄລຍະຍາວແຕ່ ຄຳ ຖາມທີ່ຜ່ານມາບໍ່ໄດ້ຖືກເຜີຍແຜ່.",
    practical_exam_of_year: "ການທົດສອບພາກປະຕິບັດປີ",
    judgment_test_of_year: "ການສອບເສັງຕັດສິນ 2019",
    judgment_test_answer_of_year: "ຄຳ ຕອບກ່ຽວກັບການຕັດສິນຄະດີ 2019",
    not_yet_test_material: "ຍັງບໍ່ທັນໄດ້ສອບເສັງເຂົ້າໃນອຸດສາຫະ ກຳ ວັດຖຸດິບ",
    not_yet_test_machinery: "ຍັງບໍ່ທັນໄດ້ສອບເສັງໃນຂະ ແໜງ ການຜະລິດເຄື່ອງຈັກອຸດສາຫະ ກຳ",
    not_yet_test_electronic: "ຍັງບໍ່ທັນໄດ້ສອບເສັງເຂົ້າໃນອຸດສາຫະ ກຳ ກ່ຽວກັບໄຟຟ້າແລະເອເລັກໂຕຣນິກ",
    not_yet_test_construction: "ຍັງບໍ່ທັນໄດ້ສອບເສັງໃນອຸດສະຫະ ກຳ ກໍ່ສ້າງ",
    not_yet_test_shipbuilding: "ຍັງບໍ່ທັນໄດ້ສອບເສັງເຂົ້າໃນອຸດສະຫະ ກຳ ການຂົນສົ່ງແລະເຮືອທະເລ",
    do_automobile_not_published: "ການສອບເສັງ ກຳ ລັງ ດຳ ເນີນໃນຂະ ແໜງ ການ ບຳ ລຸງຮັກສາລົດຍົນແຕ່ ຄຳ ຖາມທີ່ຜ່ານມາບໍ່ໄດ້ຖືກເຜີຍແຜ່.",
    do_aviation_not_published: "ການສອບເສັງ ກຳ ລັງ ດຳ ເນີນໃນອຸດສະຫະ ກຳ ການບິນແຕ່ ຄຳ ຖາມທີ່ຜ່ານມາບໍ່ໄດ້ຖືກເຜີຍແຜ່.",
    do_agricultural_not_published: "ການສອບເສັງ ກຳ ລັງ ດຳ ເນີນໃນຂະ ແໜງ ກະສິ ກຳ ແຕ່ ຄຳ ຖາມທີ່ຜ່ານມາບໍ່ໄດ້ຖືກເຜີຍແຜ່.",
    do_fishery_not_published: "ການສອບເສັງ ກຳ ລັງ ດຳ ເນີນຢູ່ພາກສະ ໜາມ ການປະມົງແຕ່ ຄຳ ຖາມທີ່ຜ່ານມາບໍ່ໄດ້ຖືກເຜີຍແຜ່.",
    do_food_not_published: "ການສອບເສັງ ກຳ ລັງ ດຳ ເນີນຢູ່ໃນອຸດສະຫະ ກຳ ການຜະລິດອາຫານແລະເຄື່ອງດື່ມແຕ່ ຄຳ ຖາມທີ່ຜ່ານມາບໍ່ໄດ້ຖືກເຜີຍແຜ່.",
    do_restaurant_not_published: "ການສອບເສັງ ກຳ ລັງ ດຳ ເນີນຢູ່ໃນອຸດສະຫະ ກຳ ບໍລິການອາຫານແຕ່ ຄຳ ຖາມທີ່ຜ່ານມາບໍ່ໄດ້ຖືກເຜີຍແຜ່.",
    schedule_undecided: "(* ຕາຕະລາງບໍ່ໄດ້ຕັດສິນໃຈ)",
    year: "ປີ",
    month: "ດວງຈັນ",
    texts_learning: "ປື້ມແບບຮຽນ ສຳ ລັບການຮຽນຮູ້ແຕ່ລະອຸດສາຫະ ກຳ",
    texts_learning_test: "ຕົວ ໜັງ ສືການຮຽນປະເມີນຜົນທັກສະສະເພາະ (ພາສາຍີ່ປຸ່ນ)",
    skill_test_sample: "ຕົວຢ່າງການປະເມີນຜົນສີມືແຮງງານ",
    japanese_test_sample: "ຕົວຢ່າງການສອບເສັງປະເມີນຜົນຂອງຍີ່ປຸ່ນ",
    not_building_texts: "ຍັງບໍ່ທັນມີປື້ມຮຽນ ສຳ ລັບອຸດສາຫະ ກຳ ເຮັດຄວາມສະອາດອາຄານເທື່ອ.",
    not_material_texts: "ຍັງບໍ່ທັນມີປື້ມຮຽນ ສຳ ລັບອຸດສາຫະ ກຳ ວັດຖຸດິບເທື່ອ.",
    not_machinery_texts: "ຂະນະທີ່ການຜະລິດເຄື່ອງຈັກອຸດສາຫະ ກຳ ຍັງບໍ່ມີປື້ມຮຽນຮູ້.",
    not_electronic_texts: "ຍັງບໍ່ທັນມີປື້ມຮຽນ ສຳ ລັບອຸດສາຫະ ກຳ ທີ່ກ່ຽວຂ້ອງກັບຂໍ້ມູນຂ່າວສານດ້ານໄຟຟ້າແລະເອເລັກໂຕຣນິກເທື່ອ.",
    not_shipbuilding_texts: "ຍັງບໍ່ທັນມີປື້ມຮຽນ ສຳ ລັບອຸດສະຫະ ກຳ ການກໍ່ສ້າງເຮືອ / ອຸດສາຫະ ກຳ ທາງທະເລເທື່ອ.",
    not_automobile_texts: "ຍັງບໍ່ທັນມີປື້ມຮຽນ ສຳ ລັບອຸດສາຫະ ກຳ ບຳ ລຸງຮັກສາລົດຍົນເທື່ອ.",
    not_accommodation_texts: "ຍັງບໍ່ທັນມີປື້ມຮຽນ ສຳ ລັບອຸດສະຫະ ກຳ ທີ່ພັກອາໃສເທື່ອ.",
    not_food_texts: "ຍັງບໍ່ທັນມີປື້ມຮຽນ ສຳ ລັບອຸດສະຫະ ກຳ ການຜະລິດອາຫານແລະເຄື່ອງດື່ມເທື່ອ.",
    not_restaurant_texts: "ປື້ມ ຕຳ ລາຮຽນກ່ຽວກັບການສອບເສັງທັກສະການບໍລິການອາຫານ",
    each_depertment_texts: "ປື້ມແບບຮຽນ ສຳ ລັບການຮຽນການສອບເສັງໃນແຕ່ລະພະແນກ",
    skill_test_basic: "ບົດຮຽນການປະເມີນຜົນສີມືແຮງງານ (ເຕັກໂນໂລຢີພື້ນຖານ)",
    skill_test_safety: "ຂໍ້ຄວາມການຮຽນການປະເມີນຜົນສີມືແຮງງານ (ຄວາມປອດໄພ / ຄຸນນະພາບການເຮັດວຽກ)",
    skill_test_aircraft: "ຂໍ້ມູນການຮຽນການປະເມີນຜົນສີມືແຮງງານ (ພາບລວມຂອງຍົນ)",
    texts_livestock: "[ປື້ມຮຽນ ສຳ ລັບການຮຽນຮູ້ການລ້ຽງສັດ] ສະບັບພາສາຍີ່ປຸ່ນ",
    texts_cultivated: "[ຂໍ້ຄວາມ ສຳ ລັບການຮຽນຮູ້ການກະສິ ກຳ ປູກຝັງ] ສະບັບພາສາຍີ່ປຸ່ນ",
    skill_test_fishery: "ການສອບເສັງວັດແທກທັກສະການປະມົງ (ການປະມົງ)",
    skill_test_general_fishery: "ການສອບເສັງວັດແທກທັກສະການປະມົງ (ການປະມົງທົ່ວໄປ)",
    skill_test_safety_fishery: "ການສອບເສັງວັດແທກທັກສະການປະມົງ (ຄວາມປອດໄພດ້ານການປະມົງ)",
    skill_test_specialty_fishery: "ການສອບເສັງວັດແທກທັກສະການປະມົງ (ທີ່ກ່ຽວຂ້ອງກັບການປະມົງພິເສດກ່ຽວກັບການປະມົງ)",
    skill_test_related_fishery: "ການສອບເສັງວັດແທກທັກສະການປະມົງ (ຄວາມຊ່ຽວຊານດ້ານການຫາປາທີ່ກ່ຽວຂ້ອງ)",
    skill_test_aquaculture: "ການສອບເສັງວັດແທກທັກສະການປະມົງ (ການລ້ຽງປາ)",
    skill_test_general_aquaculture: "ການສອບເສັງວັດແທກທັກສະການປະມົງ (ສັດນໍ້າທົ່ວໄປ / ຄວາມປອດໄພ)",
    skill_test_feeding_aquaculture: "ການສອບເສັງວັດແທກທັກສະການປະມົງ (ການຫາປາແລະການລ້ຽງປາ)",
    skill_test_non_feeding_aquaculture: "ການສອບເສັງວັດແທກທັກສະດ້ານການປະມົງ (ຕິດພັນກັບການລ້ຽງປາທີ່ບໍ່ໄດ້ປູກ)",
    registration_skill_visa: "ການລົງທະບຽນໃບຢັ້ງຢືນການຍອມຮັບວີຊາທັກສະສະເພາະ",
    please_register_pdf_number: "ກະລຸນາລົງທະບຽນຮູບພາບຫລື PDF ຂອງໃບຢັ້ງຢືນການຜ່ານ ສຳ ລັບການໄດ້ຮັບວີຊາທັກສະສະເພາະແລະເລກທີໃບຢັ້ງຢືນຜ່ານ ໜັງ ສືຜ່ານແດນ.",
    regist_and_get_cash_bag: "ຖ້າທ່ານລົງທະບຽນດຽວນີ້, ທ່ານສາມາດໄດ້ຮັບເງິນ 5000 ຢວນພ້ອມດ້ວຍກະເປົາເງິນ.",
    thank_you_regist_visa_pass: "ຂອບໃຈ ສຳ ລັບການລົງທະບຽນໃບຢັ້ງຢືນການຜ່ານວີຊາທັກສະສະເພາະ!",
    exam_info_detail: "ຮູບແບບການຈັດຕັ້ງປະຕິບັດການສອບເສັງ",
    em_exam_detail_language: "ວາງແຜນທີ່ຈະເຮັດເປັນພາສາທ້ອງຖິ່ນ",
    em_exam_detail_method: "ການສອບເສັງພາກວິຊາ, ການສອບເສັງພາກປະຕິບັດ",
    em_exam_detail_way: "ວິທີການທົດສອບເຈ້ຍທີ່ໃຊ້ຄອມພິວເຕີ (CBT) ຫຼືວິທີການທົດສອບວຽກເຊັ່ນການຜະລິດ",
    em_exam_detail_section: "19 ປະເພດການສອບເສັງ (ການຫລໍ່, ການປອມ, ການຫລໍ່ຫລໍ່, ເຄື່ອງຈັກ, ການຕິດເຫລັກ, ການເຮັດເຫລັກ, ແຜ່ນໂລຫະໂຮງງານ, ແຜ່ນ, ອາລູມີນຽມ, ສຳ ເລັດ, ກວດກາກົນຈັກ, ບຳ ລຸງຮັກສາເຄື່ອງ, ການປະກອບອຸປະກອນເອເລັກໂຕຣນິກ, ການປະກອບອຸປະກອນໄຟຟ້າ, ການຜະລິດກະດານໄຟຟ້າທີ່ພິມ, ການຜະລິດພາດສະຕິກ , ການແຕ້ມຮູບ, ການເຊື່ອມໂລຫະ, ການຫຸ້ມຫໍ່ອຸດສາຫະ ກຳ)",
    em_exam_detail_notify: "ຫຼັງຈາກການສອບເສັງ, ສົ່ງແຈ້ງການຜົນໂດຍທາງອີເມວ.",
    em_exam_detail_border: "ການທົດສອບພະແນກ: 65% ຫຼືຫຼາຍກວ່ານັ້ນ \n ການທົດສອບພາກປະຕິບັດ: 60 ຄະແນນຫຼືຫຼາຍກວ່ານັ້ນ",
    ss_exam_detail_language: "ຍີ່ປຸ່ນ",
    ss_exam_detail_method: "ການທົດສອບຄວາມສາມາດແມ່ນ ດຳ ເນີນໂດຍການທົດສອບຕົວຈິງແລະການທົດສອບຂອງພະແນກ. \n ການສອບເສັງພາກປະຕິບັດແມ່ນໄດ້ເຮັດ ສຳ ລັບແຕ່ລະ ໝວດ ທຸລະກິດ. \n ການທົດສອບພະແນກແມ່ນເຮັດ ສຳ ລັບແຕ່ລະ ໝວດ ທຸລະກິດໂດຍວິທີການທົດສອບເຈ້ຍ.",
    ss_exam_detail_way: "ວິທີການທົດສອບເຈ້ຍ, ອື່ນໆ.",
    ss_exam_detail_section: "ພາກວິຊາ / ພາກປະຕິບັດ / ທັກສະ: ການເຊື່ອມໂລຫະ, ແຕ້ມຮູບ, ເຫຼັກ, ສຳ ເລັດຮູບ, ເຄື່ອງຈັກ, ການປະກອບອຸປະກອນໄຟຟ້າ",
    ss_exam_detail_notify: "-",
    ss_exam_detail_border: "ການທົດສອບພະແນກ: 60% ຫຼືຫຼາຍກວ່ານັ້ນ \n ການທົດສອບພາກປະຕິບັດ: ການຕັດສິນໂດຍອີງໃສ່ຜົນໄດ້ຮັບຕົວຈິງ",
    c_exam_detail_language: "ຍີ່ປຸ່ນ",
    c_exam_detail_method: "ການທົດສອບຄວາມສາມາດແມ່ນ ດຳ ເນີນໂດຍການທົດສອບຕົວຈິງແລະການທົດສອບຂອງພະແນກ.",
    c_exam_detail_way: "ການທົດລອງໃຊ້ຄອມພີວເຕີ້ (CBT), ການທົດສອບພາກປະຕິບັດແມ່ນວິທີການທີ່ລະບຸໂດຍບໍລິສັດທີ່ລົງທະບຽນ",
    c_exam_detail_section: "-",
    c_exam_detail_notify: "ເຜີຍແຜ່ໃນເວບໄຊທ໌",
    c_exam_detail_border: "ການທົດສອບຂອງພະແນກ: 65% ຫຼືຫຼາຍກວ່ານັ້ນ \n ການທົດສອບພາກປະຕິບັດ: ການຕັດສິນໂດຍອີງໃສ່ຜົນໄດ້ຮັບຕົວຈິງ",
    cm_exam_detail_language: "ຍີ່ປຸ່ນ",
    cm_exam_detail_method: "ການທົດສອບຄວາມສາມາດແມ່ນ ດຳ ເນີນໂດຍການທົດສອບຕົວຈິງແລະການທົດສອບຂອງພະແນກ.",
    cm_exam_detail_way: "ປະຕິບັດການສອບເສັງທາງວິຊາການແລະພາກປະຕິບັດໂດຍການທົດສອບຄອມພີວເຕີ້ (CBT)",
    cm_exam_detail_section: "ຫົວຂໍ້ການສອບເສັງວິຊາການ \n ຄວາມຮູ້ເບື້ອງຕົ້ນກ່ຽວກັບໂຄງສ້າງ, ໜ້າ ທີ່ແລະວິທີການຮັກສາ \n ຄວາມຮູ້ເບື້ອງຕົ້ນກ່ຽວກັບການກວດກາ, ສ້ອມແປງແລະດັດປັບ \n ຄວາມຮູ້ເບື້ອງຕົ້ນກ່ຽວກັບໂຄງສ້າງ, ໜ້າ ທີ່ແລະວິທີການຈັດການຂອງເຄື່ອງທົດສອບ, ເຄື່ອງມືວັດແລະເຄື່ອງມືໃນການ ບຳ ລຸງຮັກສາ \n ຄວາມຮູ້ເບື້ອງຕົ້ນ ກ່ຽວກັບຄຸນສົມບັດແລະການ ນຳ ໃຊ້ວັດສະດຸແລະເຊື້ອໄຟແລະໄຂມັນ \n ຫົວຂໍ້ການສອບເສັງປະ ຈຳ ຕົວ \n ວຽກພື້ນຖານງ່າຍດາຍ \nB ການຖອດປະກອບ, ການກວດກາແລະການປັບຕົວງ່າຍດາຍ \nC ການສ້ອມແປງງ່າຍ \nD ງ່າຍຕໍ່ການ ນຳ ໃຊ້ເຄື່ອງທົດລອງ ບຳ ລຸງຮັກສາ, ເຄື່ອງວັດແທກແລະເຄື່ອງມື.",
    cm_exam_detail_notify: "",
    cm_exam_detail_border: "ການທົດສອບຂອງພະແນກ: 65% ຫຼືຫຼາຍກວ່ານັ້ນການທົດສອບພາກປະຕິບັດ: ຄະແນນລວມ 60% ຂຶ້ນໄປ",
    a_exam_detail_language: "ພາສາທ້ອງຖິ່ນແລະພາສາຍີ່ປຸ່ນ",
    a_exam_detail_way: "ການທົດລອງໃຊ້ຄອມພີວເຕີ້ (CBT), ວິທີການທົດສອບເຈ້ຍ",
    a_exam_detail_section: "ກົມປູກຝັງກະສິ ກຳ ໂດຍທົ່ວໄປ, ຄວາມປອດໄພແລະສຸຂະພາບ, ແນວພັນ / ຄຸນລັກສະນະຂອງພືດປູກ, ສະພາບແວດລ້ອມການປູກຝັງ (ສະຖານທີ່ / ອຸປະກອນ / ວັດສະດຸ / ເຄື່ອງຈັກ), ວິທີການປູກ / ການຄຸ້ມຄອງ, ການຄວບຄຸມສັດຕູພືດ / ສັດຕູພືດ, ການເກັບກ່ຽວ / ການປັບຕົວ / ການເກັບຮັກສາ / ການຂົນສົ່ງ obs ການສັງເກດຂອງດິນ, ການຈັດການຝຸ່ນ / ຢາປາບສັດຕູພືດ, ການຈັດການແນວພັນ, ການຈັດການສິ່ງແວດລ້ອມ, ການຈັດການວັດສະດຸ / ອຸປະກອນ / ເຄື່ອງຈັກ, ວຽກງານທີ່ກ່ຽວຂ້ອງກັບການປູກຝັງ, ຄວາມປອດໄພແລະສຸຂະພາບ③ຮັບຟັງເນື້ອໃນຂອງວຽກງານກະສິ ກຳ ທີ່ແນະ ນຳ ເປັນພາສາຍີ່ປຸ່ນ",
    a_exam_detail_notify: "ເຜີຍແຜ່ໃນເວບໄຊທ໌",
    a_exam_detail_border: "ຄະແນນທັງ ໝົດ ເກີນຈຸດອ້າງອິງການຕັດສິນທີ່ ກຳ ນົດໂດຍສະພາການກະເສດແຫ່ງຊາດ.",
    avi_exam_detail_method: "ການສອບເສັງຄວາມສາມາດແມ່ນການສອບເສັງພາກປະຕິບັດແລະການສອບເສັງພາກວິຊາ.",
    avi_exam_detail_section: "ຄຳ ຖາມຕ່າງໆຈະເອົາມາຈາກບົດເລື່ອງຕ່າງໆທີ່ລົງໃນເວັບໄຊທ໌ຂອງສະມາຄົມເຕັກໂນໂລຢີການບິນຍີ່ປຸ່ນ. ການສະຫລຸບທັກສະໃນພາກປະຕິບັດຕົວຈິງ, ການວັດແທກໄຟຟ້າ",
    avi_exam_detail_notify: "",
    avi_exam_detail_border: "ການທົດສອບຂອງພະແນກ: 65% ຫຼືຫຼາຍກວ່ານັ້ນການທົດສອບພາກປະຕິບັດ: ຄະແນນທັງ ໝົດ 65% ຂຶ້ນໄປ",
    f_exam_detail_language: "ຍີ່ປຸ່ນ",
    f_exam_detail_method: "ການທົດສອບຄວາມສາມາດແມ່ນ ດຳ ເນີນໂດຍການທົດສອບຕົວຈິງແລະການທົດສອບຂອງພະແນກ.",
    f_exam_detail_way: "ປະຕິບັດການສອບເສັງທາງວິຊາການແລະພາກປະຕິບັດໂດຍການທົດສອບຄອມພີວເຕີ້ (CBT)",
    f_exam_detail_section: "ຫົວຂໍ້ການທົດສອບຕ້ອງຢັ້ງຢືນວ່າລະດັບໃດ ໜຶ່ງ ຂອງການເຮັດວຽກໃນຂົງເຂດການປະມົງ (ການປະມົງ) ຫລືພາກສະ ໜາມ ການປະມົງ (ການລ້ຽງປາ) ສາມາດປະຕິບັດໄດ້ຢ່າງຖືກຕ້ອງໂດຍເຂົ້າໃຈ ຄຳ ແນະ ນຳ ຂອງຜູ້ຄວບຄຸມຫລືສາມາດປະຕິບັດໄດ້ຕາມການຕັດສິນໃຈຂອງຕົນເອງ, ແລະເປັນພຽງຊ່ຽວຊານ . ມັນບໍ່ແມ່ນການປະເມີນຜົນຂອງການມີຫລືບໍ່ມີຄວາມຮູ້, ແຕ່ມັນຍັງສາມາດປະເມີນການມີຫລືການພິພາກສາທີ່ຖືກຕ້ອງແລະຄວາມຮູ້ໃນການເຮັດວຽກທີ່ ຈຳ ເປັນ ສຳ ລັບການປະຕິບັດວຽກໃນຂົງເຂດການປະມົງ (ການປະມົງ) ຫລືພາກສະ ໜາມ ການປະມົງ (ການລ້ຽງປາ).",
    f_exam_detail_notify: "ເຜີຍແຜ່ໃນເວບໄຊທ໌",
    f_exam_detail_border: "ຜູ້ທີ່ມີຄະແນນທັງ ໝົດ ຂອງການສອບເສັງເປັນລາຍລັກອັກສອນແລະການທົດສອບພາກປະຕິບັດເກີນກວ່າມາດຕະຖານຄະແນນຕັດສິນທີ່ອົງການຈັດຕັ້ງປະຕິບັດທົດສອບຄວາມສາມາດໄດ້ຮັບການຍອມຮັບ.",
    no_exam_info: "ຍັງບໍ່ທັນມີຂໍ້ມູນສະຫຼຸບສັງລວມການທົດສອບເທື່ອ",
    language: "ພາສາການຈັດຕັ້ງປະຕິບັດ",
    method: "ວິທີການຈັດຕັ້ງປະຕິບັດ",
    way: "ວິທີການຈັດຕັ້ງປະຕິບັດ",
    section: "ປະເພດ Exzmination",
    notify: "ແຈ້ງການຜົນການກວດສອບ",
    border: "ເງື່ອນໄຂການສອບເສັງ",
    go_line_at: "ເຖິງເສັ້ນ @",
    thank_you_and_deactivate: "ຂໍຂອບໃຈທ່ານທີ່ໃຊ້. ສຳ ລັບຂັ້ນຕອນໃນການຖອນເງິນຈາກການບໍລິການ, ກະລຸນາໃສ່ຂັ້ນຕອນການຖອນເງິນຈາກປ່ອງ @ ຂ້າງລຸ່ມ ເພື່ອຍົກເລີກການຈ່າຍເງິນປົກກະຕິ, ກະລຸນາໃສ່ການຍົກເລີກການຈ່າຍເງິນປົກກະຕິຈາກປ່ອງ @ line line ຂ້າງລຸ່ມ. ພວກເຮົາຈະປະຕິບັດຂັ້ນຕອນໃນທັນທີທີ່ພວກເຮົາໄດ້ຮັບການຢັ້ງຢືນ.",
    thank_you_and_subscribe: "ຂອບໃຈທີ່ໃຊ້. ເພື່ອຍົກເລີກການຈ່າຍເງິນປົກກະຕິ, ກະລຸນາໃສ່ການຍົກເລີກການຈ່າຍເງິນປົກກະຕິຈາກປ່ອງ @ line line ຂ້າງລຸ່ມ. \n ພວກເຮົາຈະຍົກເລີກສັນຍາດັ່ງກ່າວທັນທີທີ່ພວກເຮົາໄດ້ຮັບການຢືນຢັນ.",
    ten_thousand_yen: "ສິບພັນເຢນ",
    yen_per_month: "JPY / ເດືອນ",
    how_to_use_this_service: "ກະແສການ ນຳ ໃຊ້",
    selecting_a_browser: "ການເລືອກຕົວທ່ອງເວັບ",
    selecting_a_browser_dec: "ເຂົ້າໃຊ້ https://aelu.co.jp ດ້ວຍໂປແກຼມທ່ອງເວັບ (Google chrome, Safari, edge, ແລະອື່ນໆ) * ບໍ່ມີແອັບ app.",
    provisional_registration: "ການລົງທະບຽນຊົ່ວຄາວ",
    provisional_registration_dec: "ເຂົ້າສູ່ລະບົບດ້ວຍ Facebook ຫຼື Google ID ຂອງທ່ານຫຼືລົງທະບຽນກັບທີ່ຢູ່ອີເມວຂອງທ່ານ. ຫຼັງຈາກເລືອກພາສາທີ່ຕ້ອງການແລະອາຊີບທີ່ຕ້ອງການ, ທ່ານສາມາດເອີ້ນເບິ່ງເນື້ອຫາໃນການສອບເສັງຜ່ານການຢັ້ງຢືນຜ່ານທາງອິນເຕີເນັດ.",
    full_registration: "ການລົງທະບຽນຫລັກ",
    full_registration_dec: "ກົດ“ ການລົງທະບຽນຫລັກ” ໃນ ໜ້າ ເນື້ອຫາການສອບເສັງໃບຢັ້ງຢືນທາງອິນເຕີເນັດ, ຕື່ມຂໍ້ມູນທີ່ຕ້ອງການ, ແລະໃຊ້ບໍລິການທັງ ໝົດ ລວມທັງ 14 ຄຳ ຖາມກ່ຽວກັບການປະຕິບັດການສອບເສັງເພື່ອການຢັ້ງຢືນອຸດສາຫະ ກຳ.",
    name_validate_message: "ກະລຸນາໃສ່ຂໍ້ມູນດ້ວຍການສະກົດທີ່ຄືກັນກັບທີ່ມັນປາກົດຢູ່ໃນ ໜັງ ສືເດີນທາງຂອງທ່ານ.",
    live_at_area: "ພື້ນທີ່ທີ່ທ່ານອາໄສຢູ່ໃນປະຈຸບັນ",
    agency_application: "ປະຕິບັດການສະ ໝັກ",
    mypage: "ໜ້າ ຂອງຂ້ອຍ",
    myanmar: "ມຽນມາ",
    exam_list: "ບັນຊີລາຍຊື່ຕາຕະລາງການສອບເສັງ",
    no: "ບໍ່.",
    times: "ເທື່ອ",
    application_start: "ເລີ່ມສະ ໝັກ",
    application_end: "ເສັ້ນຕາຍຄັ້ງສະ ໝັກ",
    enforcement: "ການຈັດຕັ້ງປະຕິບັດ",
    applicated: "ໃຊ້ແລ້ວ",
    reception_time: "ເວລາຕ້ອນຮັບ",
    announthment_d: "ວັນທີປະກາດຮັບເອົາ",
    reception_period: "ໄລຍະເວລາການສະ ໝັກ",
    detail_link: "ກວດເບິ່ງລາຍລະອຽດ",
    exam_country: "ປະ​ເທດ​ເຈົ້າ​ພາບ",
    line: "ເສັ້ນ",
    vietnum: "ຫວຽດນາມ",
    laos: "ປະເທດລາວ",
    malaysia: "ມາເລເຊຍ",
    bangladesh: "ບັງກະລາເທດ",
    indo: "ອິນເດຍ",
    nepal: "ເນປານ",
    mongol: "ມົງໂກລີ",
    indonesia: "ອິນໂດເນເຊຍ",
    th: "ປະເທດໄທ",
    philipine: "ຟີລິບປິນ",
    my: "ມຽນມາ",
    uzbekistan: "ອຸສເບກິສຖານ",
    pakistan: "ປາກິສຖານ",
    japan: "ຍີ່ປຸ່ນ",
    news_title: "ຂ່າວກ່ຽວກັບວີຊາທັກສະສະເພາະ",
    missNowPassword: "ລະຫັດຜ່ານປະຈຸບັນແມ່ນບໍ່ຖືກຕ້ອງ",
    article6_sub2_dec2: "ຖ້າທ່ານສະ ໝັກ ຢູ່ນີ້, ພວກເຮົາຍັງຈະປະກາດຮັບສະ ໝັກ ການສອບເສັງ, ລາຄາ exm, ແລະສະຖານທີ່ຈົນຮອດມື້ສອບເສັງ.",
    create_naw_password: "ປ່ຽນ​ລະ​ຫັດ​ຜ່ານ",
    send_confirmcode: "ລະຫັດຢືນຢັນໄດ້ຖືກສົ່ງໄປແລ້ວ",
    edit: "ປ່ຽນແປງ",
    success_new_password_setting: "ທ່ານໄດ້ຕັ້ງລະຫັດລັບ ໃໝ່ ແລ້ວ.",
    error_email: "ນີ້ແມ່ນທີ່ຢູ່ອີເມວທີ່ບໍ່ໄດ້ລົງທະບຽນ.",

    click_here_businesses: "ກົດບ່ອນນີ້ ສຳ ລັບທຸລະກິດ",
    regist_organization_staff_info: "ການລົງທະບຽນຂໍ້ມູນທຸລະກິດ / ຜູ້ໃຊ້",
    organization_info: "ຂໍ້ມູນທຸລະກິດ",
    staff_info: "ຂໍ້ມູນຜູ້ໃຊ້",
    org_name: "ຊື່​ທຸ​ລະ​ກິດ",
    url: "URL",
    org_scale: "ຂະ ໜາດ",
    org_zip: "ລະ​ຫັດ​ໄປ​ສະ​ນີ",
    org_adress1: "ເຂດປົກຄອງ",
    org_adress2: "ເທດສະບານ",
    org_adress3: "ຊື່ທີ່ຢູ່ / ອາພາດເມັນ",
    org_industry: "ອຸດສາຫະ ກຳ",
    org_category: "ໝວດ",
    org_description: "ລາຍລະອຽດ",
    org_established_at: "ປີແຫ່ງການສ້າງຕັ້ງ",
    org_phone: "ເບີໂທລະສັບທຸລະກິດ",
    failed_established_at: "ວັນທີທີ່ບໍ່ຖືກຕ້ອງ.",
    staff_name: "ຊື່ຜູ້ໃຊ້",
    form_miss: "ມີຂໍ້ຜິດພາດໃນແບບຟອມການປ້ອນຂໍ້ມູນ.",
    back_joboffer_detail: "ກັບໄປຫາລາຍລະອຽດວຽກ <",
    create_joboffer: "ສ້າງວຽກເຮັດງານ ທຳ",
    edit_joboffer: "ແກ້ໄຂວຽກ",
    stop_posting: "ຢຸດການໂພດ",
    delete: "ລົບ",
    job_title: "ຕໍາ​ແຫນ່ງ",
    job_catch_phrase: "ປະໂຫຍກທີ່ຈັບວຽກ",
    job_category: "ປະເພດອາຊີບ",
    employed_company_name: "ຊື່ບໍລິສັດທີ່ເຮັດວຽກ",
    work_location: "ສະຖານທີ່ເຮັດວຽກ",
    employment_status: "ສະຖານະພາບການຈ້າງງານ",
    full_time_employee: "ພະນັກງານເຕັມເວລາ",
    part_time_job: "ວຽກ​ເສີມ",
    temporary_staff: "ແຮງງານທີ່ອອກແຮງງານ",
    contract_employee: "ພະນັກງານສັນຍາຈ້າງ",
    intern: "ນັກຮຽນຝຶກຫັດ",
    subcontracting: "ການຕໍ່ສັນຍາ",
    contract: "ສັນຍາ",
    new_graduate: "ຈົບການສຶກສາ ໃໝ່",
    salary: "ເງິນເດືອນ",
    annual_income: "ລາຍ​ຮັບ​ປະ​ຈໍາ​ປີ",
    monthly_salary: "ເງິນເດືອນປະ ຈຳ ເດືອນ",
    weekly_salary: "ເງິນເດືອນປະ ຈຳ ອາທິດ",
    dayly_salary: "ເງິນເດືອນປະ ຈຳ ວັນ",
    job_offer_attension1: "ມັນ ຈຳ ເປັນຕ້ອງໄດ້ ກຳ ນົດຢ່າງຈະແຈ້ງກ່ຽວກັບເງື່ອນໄຂການເຮັດວຽກທີ່ໄດ້ ກຳ ນົດໄວ້, ແລະອື່ນໆ ສຳ ລັບເນື້ອໃນການເຮັດວຽກໃຫ້ສອດຄ່ອງກັບກົດ ໝາຍ.",
    job_offer_attension2: "ກະລຸນາກວດເບິ່ງສະພາບການເຮັດວຽກ, ແລະອື່ນໆ. ທີ່ ຈຳ ເປັນຕ້ອງໄດ້ຖືກ ກຳ ນົດໄວ້ໃນກົດ ໝາຍ ຢ່າງຈະແຈ້ງ, ແລະຫຼັງຈາກນັ້ນອະທິບາຍເນື້ອໃນຂອງການເຮັດວຽກ. (ກະສານອ້າງອີງ: ກະຊວງສາທາລະນະສຸກ, ແຮງງານແລະສະຫວັດດີການ, ສຳ ນັກງານແຮງງານເຂດ &quot;ໃຫ້ແກ່ທຸກໆບໍລິສັດທີ່ຮັບສະ ໝັກ ພະນັກງານ&quot;)",
    job_offer_attension3: "ວຽກອາດຈະບໍ່ຖືກລົງເຜີຍແຜ່ຖ້າທ່ານໃຊ້ພາສາທີ່ ຈຳ ກັດອາຍຸ, ເພດ, ຫຼືສະຖານະພາບທາງສັງຄົມ.",
    job_offer_attension4: "ຕົວຢ່າງທີ່ບໍ່ໄດ້ເຜີຍແຜ່ເລື້ອຍໆ: &quot;ຍິນດີຕ້ອນຮັບສູ່ປີ 20&quot; &quot;ຍິນດີຕ້ອນຮັບຊາວ ໜຸ່ມ (ຊາວ ໜຸ່ມ)&quot; &quot;ແມ່ຍິງຍິນດີຕ້ອນຮັບ / ຈຳ ກັດ&quot; &quot;ນັກຮຽນເທົ່ານັ້ນ&quot;",
    work_content_appeal: "ເນື້ອໃນການເຮັດວຽກແລະຈຸດອຸທອນ",
    work_content_appeal_desc: "ມັນຈະງ່າຍກວ່າ ສຳ ລັບຜູ້ຊອກວຽກທີ່ຈະສົນໃຈຖ້າທ່ານບອກພວກເຂົາຈຸດອຸທອນກ່ອນ.",
    human_resources_seek: "ຊັບ​ພະ​ຍາ​ກອນ​ມະ​ນຸດ",
    human_resources_seek_desc: "ຂໍໃຫ້ສົ່ງເຖິງຄວາມສາມາດທີ່ທ່ານ ກຳ ລັງຊອກຫາບໍ່ພຽງແຕ່, ແຕ່ຍັງມີຂໍ້ມູນທີ່ຊ່ວຍໃຫ້ຜູ້ຊອກວຽກເຮັດໃນສະຖານທີ່ເຮັດວຽກ.",
    working_hours: "ຊົ່ວ​ໂມງ​ເຮັດ​ວຽກ",
    traffic_access: "ການເຂົ້າຊົມການຈາລະຈອນ",
    traffic_access_desc: "ນອກ ເໜືອ ຈາກຂໍ້ມູນການຂົນສົ່ງສາທາລະນະ, ປະກອບມີຂໍ້ມູນເຊັ່ນ: ການເດີນທາງໂດຍລົດແລະວ່າມີບ່ອນຈອດລົດ ສຳ ລັບພະນັກງານ.",
    required: "ບັງຄັບ",
    optional: "ໃດໆ",
    other: "ອື່ນໆ",
    photo: "ຮູບພາບ",
    upload_video: "ອັບໂຫລດວິດີໂອ",
    job_tag: "ປ້າຍ ກຳ ກັບວຽກ",
    until_select_three: "ເຖິງ 3 ສາມາດເລືອກໄດ້",
    senior_support: "ການສະ ໜັບ ສະ ໜູນ ອາວຸໂສ",
    salary_increase_promotion: "ມີການຂື້ນ / ຂື້ນເງິນເດືອນ",
    no_overtime: "ບໍ່ເຮັດວຽກລ່ວງເວລາ",
    target_hiring_time: "ເປົ້າ ໝາຍ ໃນການຈ້າງເວລາ",
    additional_questions: "ຄຳ ຖາມເພີ່ມເຕີມ",
    job_offer_title: "ຊື່ວຽກ",
    public: "ປ່ອຍຕົວ",
    private: "ເອກະຊົນ",
    public_status: "ສະຖານະພາບສາທາລະນະ",
    occupation: "ອາຊີບ",
    walfare: "ການຮັກສາ / ສະຫວັດດີການ",
    create: "ສ້າງ",
    hour: "ເວລາ",
    back_mypage: "ກັບໄປ ໜ້າ ຂອງຂ້ອຍ <",
    job_offers: "ລາຍຊື່ວຽກ",
    look_matches: "ເບິ່ງລາຍຊື່ການຈັບຄູ່",
    now_public: "ຕອນນີ້ເປີດແລ້ວ",
    now_private: "ສ່ວນຕົວ",
    check: "ຢືນຢັນ",
    edit2: "ເພື່ອແກ້ໄຂ",
    news_detail: "ລາຍລະອຽດຂ່າວສານ",
    prefectures: "ເຂດປົກຄອງ",
    hokkaido: "ຮອກໄກໂດ",
    aomori: "Aomori",
    iwate: "Iwate",
    miyagi: "ມິມີກີ",
    akita: "ອາກີຕາ",
    yamagata: "Yamagata",
    fukushima: "ຟຸກຸຊິມະ",
    ibaraki: "ອິບາລາກີ",
    tochigi: "ໂຕຊິກີ",
    gunma: "Gunma",
    saitama: "ໄຊທານາ",
    chiba: "ຊິບບາ",
    tokyo: "ໂຕກຽວ",
    kanagawa: "ການາກາວາ",
    niigata: "Niigata",
    toyama: "Toyama",
    ishikawa: "Ishikawa",
    fukui: "ຟູກູ",
    yamanashi: "Yamanashi",
    nagano: "ນາກາໂນ",
    gifu: "Gifu",
    shizuoka: "Shizuoka",
    aichi: "ອາຊິ",
    mie: "ສາມເທົ່າ",
    shiga: "ຊາກາ",
    kyoto: "ກຽວໂຕ",
    osaka: "ໂອຊາກາ",
    hyogo: "ໄຮໂກໂກ",
    nara: "ນາຣາ",
    wakayama: "Wakayama",
    tottori: "ທາໂຕໂຕ້",
    shimane: "Shimane",
    okayama: "ໂອກາຢາມາ",
    hiroshima: "ເມືອງຮິໂຣຊິມະ",
    yamaguti: "Yamaguchi",
    tokushima: "ໂທກຸຊິມະ",
    kagawa: "ກາກາວາ",
    echime: "ອີຮິມ",
    kochi: "Kochi",
    fukuoka: "Fukuoka",
    saga: "Saga",
    nagasaki: "ນາກາຊາກິ",
    kumamoto: "Kumamoto",
    oita: "ໂອຕາ",
    miyazaki: "Miyazaki",
    kagoshima: "Kagoshima",
    okinawa: "ໂອກິນາວາ",
    sinhalese: "ສິນລະປະ",
    exam_region: "ເຂດປົກຄອງ",
    exam_place_list: "ບັນຊີລາຍຊື່ສະຖານທີ່",
    exam_place_name: "ຊື່ສະຖານທີ່ສອບເສັງ",
    care_evaluation_test: "ການທົດສອບການປະເມີນຜົນການຝຶກທັກສະໃນໄລຍະຍາວ",
    clean_building_test: "ອຸດສະຫະ ກຳ ກໍ່ສ້າງ ທຳ ຄວາມສະອາດບັນຫາທີ່ຜ່ານມາ",
    answer: "ຕອບ",
    skill_test_measurement: "ການທົດສອບການວັດແທກສີມືແຮງງານ",
    exam_problem: "ຄຳ ຖາມຂອງການສອບເສັງ",
    fields: "ທົ່ງນາແລະຜັກ",
    gardening: "ການເຮັດສວນສະດວກ",
    mushroom: "ເຫັດ",
    fruit: "ຕົ້ນໄມ້ໃຫ້ ໝາກ",
    dairy: "ນົມ",
    poultry: "ການລ້ຽງສັດປີກ",
    pig: "ການລ້ຽງ ໝູ",
    beginner: "ຜູ້ເລີ່ມຕົ້ນ",
    professional: "ລະດັບວິຊາຊີບ",
    advanced: "ຂັ້ນສູງ",
    technical_training_test: "ການທົດສອບການປະເມີນຜົນການຝຶກອົບຮົມດ້ານວິຊາການ",
    exam_part: "ສ່ວນ ໜຶ່ງ ຂອງ ຄຳ ຖາມສອບເສັງ",
    tokoha_fruit: "ຕົ້ນໄມ້ໃຫ້ ໝາກ Tokoha",
    deciduous_fruit: "ຕົ້ນໄມ້ໃຫ້ ໝາກ",
    ver: "ສະບັບ",
    errata: "errata",
    form_work: "ການກໍ່ສ້າງແບບຟອມ",
    construction: "ຊ່າງປັ້ນ",
    tunnel_line: "ເສັ້ນກະຕຸ້ນອຸໂມງ",
    earth_work: "ວຽກໂລກ",
    loofing: "ຫລັງຄາ",
    elecommunication: "ໂທລະຄົມມະນາຄົມ",
    reinforcing_contstruction: "ເສີມ ກຳ ລັງການກໍ່ສ້າງແຖບ",
    reinforcing_joint: "ການເສີມ ກຳ ລັງຂອງທະນາຍຄວາມຮ່ວມກັນ",
    wall_painting: "ການທາສີ (ການປົກຫຸ້ມຂອງຝາ)",
    board_finish: "ກະດານ ສຳ ເລັດຮູບ, ສຳ ເລັດຮູບພາຍໃນ",
    steeplejack: "ໄປຫາ",
    spray_insulation: "ການສີດພົ່ນ urethane",
    marine_civil: "ວິສະວະ ກຳ ໂຍທາທາງທະເລ",
    concrete_pumping: "ການສູບສີມັງ",
    construction_machinery: "ການກໍ່ສ້າງເຄື່ອງຈັກການກໍ່ສ້າງ",
    learning_text: "ການຮຽນຮູ້ ໜັງ ສື",
    basic_aircraft: "ການສະຫລຸບເຕັກໂນໂລຢີຂັ້ນພື້ນຖານຂອງເຮືອບິນ, ການວັດແທກໄຟຟ້າ",
    worksafety_quality: "ຄວາມປອດໄພໃນການເຮັດວຽກ, ຄຸນນະພາບ",
    aircraft_overview: "ພາບລວມຂອງເຮືອບິນ",
    fish_general: "ການປະມົງໂດຍທົ່ວໄປ",
    fish_safety: "ຄວາມປອດໄພດ້ານການປະມົງ",
    network_relations: "ສາຍ ສຳ ພັນພິເສດດ້ານການປະມົງ",
    fish_relations: "ການຫາປາແບບພິເສດກ່ຽວຂ້ອງກັບການຫາປາ",
    aquaculture_general: "ການລ້ຽງສັດນ້ ຳ ໂດຍທົ່ວໄປ",
    feeding_aquaculture: "ຄວາມຊ່ຽວຊານດ້ານການລ້ຽງສັດນ້ ຳ",
    unfed_aquaculture: "ຄວາມຊ່ຽວຊານດ້ານການລ້ຽງສັດນ້ ຳ",
    attachment: "ເອກະສານຕິດຄັດ",
    glossary: "ຄຳ ສັບ",
    feneral_customer: "ບໍລິການລູກຄ້າທົ່ວໄປ",
    food_dring_cooking: "ອາຫານແລະເຄື່ອງດື່ມປຸງແຕ່ງອາຫານ",
    hygiene_management: "ການຄຸ້ມຄອງສຸຂະອະນາໄມ",
    visa_application: "ການຍື່ນຂໍວີຊາທັກສະສະເພາະ",
    certificate_residence_tax: "1. ໃບຢັ້ງຢືນການເສຍອາກອນທີ່ພັກອາໄສ (ສຳ ລັບປີສຸດທ້າຍ)",
    salary_income_withholding : "2. ສຳ ເນົາໃບແຈ້ງເງິນຝາກ ສຳ ລັບລາຍໄດ້ເງິນເດືອນ",
    national_health_insured: "3. ສຳ ເນົາບັດປະກັນໄພສຸຂະພາບແຫ່ງຊາດ (ສຳ ລັບບຸກຄົນທີ່ລົງທະບຽນ)",
    national_health_payment: "4. ໃບຢັ້ງຢືນການ ຊຳ ລະຄ່າ ທຳ ນຽມປະກັນສຸຂະພາບແຫ່ງຊາດ",
    national_health_receipt: "5. ສຳ ເນົາໃບເກັບເງິນຄ່າປະກັນໄພສຸຂະພາບແຫ່ງຊາດ",
    technical_intern_training2: "6. ເອກະສານຢັ້ງຢືນວ່າການຝຶກອົບຮົມວິຊາການສະບັບເລກທີ 2 ໄດ້ປະສົບຜົນ ສຳ ເລັດ",
    need_the_following : "ທ່ານຕ້ອງການສິ່ງຕໍ່ໄປນີ້:",
    pass_certificate_test_specialized : "copy ສຳ ເນົາໃບປະກາດສະນີຍະບັດຂອງການທົດສອບຄວາມສາມາດຕົວຈິງຂອງການທົດສອບການປະເມີນຜົນສີມືແຮງງານ (ເກຣດພິເສດ)",
    technical_intern_training3: "copy ສຳ ເນົາໃບປະກາດສະນີຍະບັດຂອງການທົດສອບຕົວຈິງຂອງການທົດສອບສີມືແຮງງານ (ຊັ້ນທີ 3)",
    evaluation_record_technical_intern: "・ ຖ້າທ່ານບໍ່ຜ່ານການສອບເສັງຂ້າງເທິງ, ທ່ານ ຈຳ ເປັນຕ້ອງຕື່ມໃສ່ບັນທຶກການປະເມີນຜົນ ສຳ ລັບນັກຝຶກຫັດດ້ານວິຊາການ.",
    cartificate_pass_basic_test: "ໃນຖານະເປັນທາງເລືອກທີ່ 7.6, ທ່ານສາມາດສົ່ງ ສຳ ເນົາໃບຢັ້ງຢືນຜ່ານຂອງການສອບເສັງຂັ້ນພື້ນຖານຂອງມູນນິທິຍີ່ປຸ່ນຫລື ສຳ ເນົາໃບຢັ້ງຢືນຜ່ານຂອງການສອບເສັງຄວາມສາມາດດ້ານພາສາຍີ່ປຸ່ນ (N4) ຫຼືສູງກວ່າ.",
    change_permission_application: "8. ຮູບຖ່າຍໃບສະ ໝັກ ຂໍອະນຸຍາດປ່ຽນແປງ (ແນວຕັ້ງ 4 ຊຕມ x ແນວນອນ 3 ຊມ)",
    resume_data_time_entry: "9. ປະກອບຂໍ້ມູນຄືນໃນເວລາປ້ອນເຂົ້າ",
    select_file: "ເລືອກແຟ້ມເອກະສານ",
    description_movie: "ວິດີໂອອະທິບາຍ",
    how_to_use_movie: "ວິທີການໃຊ້ວິດີໂອ",
    movie_news: "1. ຂ່າວກ່ຽວກັບວີຊາທັກສະສະເພາະ",
    movie_exam: "2. ຈຳ ນວນມື້ທີ່ເຫຼືອຈົນຮອດມື້ທົດສອບ",
    movie_predict_pass: "3. ອັດຕາການຜ່ານປະມານທີ່ຄາດຄະເນ",
    movie_ave_study_test: "4. ຄະແນນສະເລ່ຍຂອງການທົດສອບຕົວເອງທີ່ທ່ານໄດ້ສຶກສາ",
    movie_similar_exam: "5. ຄຳ ຖາມສອບເສັງທີ່ຄ້າຍຄືກັນ",
    movie_learning_text: "6. ດາວໂລດປື້ມ ຕຳ ລາຮຽນ (ປື້ມແບບຮຽນ)",
    movie_solved_exam: "7. ບັນຫາທີ່ຂ້ອຍແກ້ໄຂໃນອະດີດ",
    movie_pased_exam: "8. ກ່ຽວກັບການເຫັນບັນຫາໃນອະດີດທີ່ປະກົດຕົວຈິງ",
    movie_resume_regist: "9. ສືບຕໍ່ລົງທະບຽນໃນເວລາເຂົ້າ",
    movie_pass_document_regist: "10. ການລົງທະບຽນໃບຜ່ານການສອບເສັງຄວາມສາມາດ",
    movie_agency_service: "11. ບໍລິການຕົວແທນການສະ ໝັກ ສອບເສັງ",
    movie_consule_service: "12. ບໍລິການໃຫ້ ຄຳ ປຶກສາດ້ານການຮຽນຮູ້",
    description_movie_trans: "ຖ້າທ່ານຕ້ອງການເບິ່ງເປັນພາສາອື່ນທີ່ບໍ່ແມ່ນພາສາຍີ່ປຸ່ນ, ກົດປຸ່ມເຄື່ອງ ໝາຍ, ກົດ ຄຳ ບັນຍາຍແລະການແປພາສາອັດຕະໂນມັດ, ເລືອກພາສາທີ່ທ່ານ ກຳ ເນີດ, ແລະຈາກນັ້ນເບິ່ງ.",


"cultivated_agriculture_general": "ການປູກຝັງໂດຍທົ່ວໄປ",
"livestock_agriculture": "ກະສິກຳ ລ້ຽງສັດ",
"介護": "ການພະຍາບານ",
"ビルクリーニング": "ທໍາຄວາມສະອາດອາຄານ",
"建設": "ການກໍ່ສ້າງ",
"自動車整備": "ບໍາລຸງຮັກສາລົດ",
"航空業": "ອຸດສາຫະກໍາການບິນ",
"農業": "ກະສິກຳ",
"漁業": "ການຫາປາ",
"飲食料品製造業": "ອຸດສາຫະກໍາການຜະລິດອາຫານແລະເຄື່ອງດື່ມ",
"外食業": "ທຸລະກິດຮ້ານອາຫານ",
"型枠施工": "ການກໍ່ສ້າງ Formwork",
"左官": "plasterer",
"コンクリート圧送": "ສູບຄອນກີດ",
"トンネル推進工": "ການ​ເຮັດ​ວຽກ propulsion ອຸ​ໂມງ​",
"建設機械施工": "ການກໍ່ສ້າງເຄື່ອງຈັກກໍ່ສ້າງ",
"大工": "ຊ່າງ​ໄມ້",
"屋根ふき": "ມຸງ",
"電気通信": "ໂທລະຄົມມະນາຄົມ",
"鉄筋施工": "ເສີມສ້າງບາ",
"鉄筋継手": "ການເສີມສ້າງຮ່ວມກັນຂອງແຖບ",
"壁装（壁張り）": "ຝາຜະຫນັງ (ຝາຜະຫນັງ)",
"ボード仕上げ、内装仕上げ": "ສໍາເລັດຮູບກະດານ, ສໍາເລັດຮູບພາຍໃນ",
"とび": "ໂດດ",
"吹き付けウレタン断熱": "ສີດ insulation firing",
"海洋土木工": "ວິສະວະກຳໂຍທາທາງທະເລ",
"航空機の基本技術 締結、電気計測": "ການສະຫລຸບເຕັກໂນໂລຢີພື້ນຖານຂອງເຮືອບິນ, ການວັດແທກໄຟຟ້າ",
"作業安全、品質": "ຄວາມປອດໄພໃນການເຮັດວຽກ, ຄຸນນະພາບ",
"航空機概要": "ພາບລວມຂອງເຮືອບິນ",
"耕種農業全般": "ການປູກຝັງໂດຍທົ່ວໄປ",
"畜産農業": "ກະສິກຳ ລ້ຽງສັດ",
"漁業一般": "ການຫາປາໂດຍທົ່ວໄປ",
"漁業安全": "ຄວາມປອດໄພການປະມົງ",
"漁業専門 綱関係": "ສາຍ​ພົວ​ພັນ​ພິ​ເສດ​ການ​ປະ​ມົງ",
"漁業専門 釣り関係": "ຊ່ຽວຊານໃນການຫາປາທີ່ກ່ຽວຂ້ອງກັບການຫາປາ",
"養殖業一般": "ການລ້ຽງສັດນ້ໍາໂດຍທົ່ວໄປ",
"養殖業専門 給餌養殖関係": "ການລ້ຽງປາພິເສດ ການລ້ຽງສັດນ້ຳ",
"養殖業専門 無給餌養殖関係": "Aquaculture specialty ການລ້ຽງສັດນ້ໍາ Unfed",
"接客全般": "ບໍລິການລູກຄ້າທົ່ວໄປ",
"飲食物調理": "ປຸງ​ແຕ່ງ​ອາ​ຫານ​ແລະ​ເຄື່ອງ​ດື່ມ​",
"衛生管理": "ການຄຸ້ມຄອງສຸຂະອະນາໄມ",
"日本語版": "ສະບັບພາສາຍີ່ປຸ່ນ",
"英語版": "ສະບັບພາສາອັງກິດ",
"クメール語版": "ສະບັບພາສາຂະແມ",
"インドネシア語版": "ສະບັບພາສາອິນໂດເນເຊຍ",
"インドネシア語・正誤表": "ຜິດ​ພາດ​ອິນ​ໂດ​ເນ​ເຊຍ​",
"ネパール語版": "ສະບັບພາສາເນປານ",
"モンゴル語版": "ສະບັບພາສາມົງໂກລີ",
"ビルマ語版": "ສະບັບພາສາມຽນມາ",
"ベトナム語版": "ສະບັບພາສາຫວຽດນາມ",
"タイ語版": "ສະບັບພາສາໄທ",
"テキスト１": "ຂໍ້ຄວາມ 1",
"テキスト２": "ຂໍ້ຄວາມ 2",
"テキスト３": "ຂໍ້ຄວາມ 3",
"テキスト４": "ຂໍ້ຄວາມ 4",
"テキスト５": "ຂໍ້ຄວາມ 5",
"ミャンマー(ビルマ)語版": "ສະບັບພາສາມຽນມາ (ພະມ້າ).",
"カンボジア(クメール)語版": "ສະບັບພາສາກຳປູເຈຍ (ຂະແມ).",
"ミャンマー語版": "ສະບັບພາສາມຽນມາ",
"中国語版": "ສະບັບພາສາຈີນ",
"付属資料": "ໄຟລ໌ແນບ",
"用語集": "ຄຳສັບ",

invitation_code: "ລະຫັດເຊີນ",
exam_calender: "ປະຕິທິນຕາຕະລາງການສອບເສັງ",
move_exam_detail: "ເຈົ້າຢາກໄປທີ່ໜ້າລາຍລະອຽດຕາຕະລາງການສອບເສັງບໍ່?",
move: "ການເຄື່ອນຍ້າຍ",
plece_select_language: "ກະລຸນາເລືອກພາສາ",
select: "ເລືອກ",
midle_category: "ອາຊີບ",
select_industry_description: "ໃນຕອນເລີ່ມຕົ້ນ, AELU ພຽງແຕ່ສາມາດເລືອກໄດ້ເຖິງ 3 ອຸດສາຫະກໍາ, ດັ່ງນັ້ນເລືອກພຽງແຕ່ອຸດສາຫະກໍາທີ່ທ່ານຕ້ອງການເຮັດວຽກ. ຖ້າທ່ານພໍໃຈກັບມັນ, ກົດ Next",
done_member_regist_description_2: "ຈາກນີ້ໄປ, ພວກເຮົາຈະສະຫນັບສະຫນູນ AELU ເພື່ອຂໍວີຊາທັກສະສະເພາະໂດຍການກະກຽມການສອບເສັງການຢັ້ງຢືນຫຼາຍ.",
done_member_regist_2: "ການລົງທະບຽນສະມາຊິກສຳເລັດແລ້ວ.",
is_exist_user: "ຜູ້ໃຊ້ທີ່ມີທີ່ຢູ່ອີເມວດຽວກັນມີຢູ່ແລ້ວ.",
invitation_code_description: "(ກະລຸນາໃສ່ລະຫັດເຊີນຈາກອົງການຈັດຕັ້ງສົ່ງ ຫຼື ໂຮງຮຽນພາສາຍີ່ປຸ່ນ, ຖ້າບໍ່ດັ່ງນັ້ນ ຫນ້າຈໍການຊໍາລະຄ່າໃຊ້ຈ່າຍຈະປາກົດຂຶ້ນ, ດັ່ງນັ້ນຢ່າລືມໃສ່ມັນ.)",
pleace_select_region: "ກະລຸນາເລືອກແຂວງທີ່ເປັນເຈົ້າພາບ",
pleace_add_messenger: "ຕິດ​ຕໍ່​ພົວ​ພັນ​ທັງ​ຫມົດ​ຈະ​ໄດ້​ຮັບ​ການ​ສົ່ງ​ຜ່ານ​ຂໍ້​ຄວາມ​ເຟ​ສ​ບຸກ​ສະ​ນັ້ນ​ໃຫ້​ແນ່​ໃຈວ່​າ​ຈະ​ເພີ່ມ​ໃຫ້​ເຂົາ​ເຈົ້າ​",
add_messenger_bot: "ຮັບການແຈ້ງເຕືອນ",
visa_application_description: "ສະຖານທີ່ເກັບຮັກສາເອກະສານທີ່ຕ້ອງການໃນເວລາຍື່ນຂໍວີຊາທັກສະສະເພາະ",
check_agree: "ກະລຸນາຕົກລົງ",
sample_title: "ນີ້ແມ່ນຊື່ dummy. ກະລຸນາຕັ້ງ",
sample_description: "ນີ້ແມ່ນຄໍາອະທິບາຍ dummy. ກະລຸນາຕັ້ງ. ນີ້ແມ່ນຄໍາອະທິບາຍ dummy. ກະລຸນາຕັ້ງ. ນີ້ແມ່ນຄໍາອະທິບາຍ dummy. ກະລຸນາຕັ້ງ. ນີ້ແມ່ນຄໍາອະທິບາຍ dummy. ກະລຸນາຕັ້ງ. ນີ້ແມ່ນຄໍາອະທິບາຍ dummy. ກະລຸນາຕັ້ງ. ນີ້ແມ່ນຄໍາອະທິບາຍ dummy. ກະລຸນາຕັ້ງ. ນີ້ແມ່ນຄໍາອະທິບາຍ dummy. ກະລຸນາຕັ້ງ.",
create_profile_error: "ມີຂໍ້ຜິດພາດໃນການປ້ອນຂໍ້ມູນ. ກະລຸນາກວດເບິ່ງລາຍການ",
setting_confirm: "ກະລຸນາຢືນຢັນການປ້ອນຂໍ້ມູນ ແລະລົງທະບຽນ",
exam_learning: "ການ​ຮຽນ​ຮູ້​ການ​ສອບ​ເສັງ​",
recommend_problem_solve: "ແກ້ໄຂຄໍາຖາມສອບເສັງທີ່ຄ້າຍຄືກັນ",
of: "ຂອງ",
see_solved_problem: "ແກ້ໄຂບັນຫາທີ່ທ່ານໄດ້ແກ້ໄຂໃນອະດີດ\n",
past_exam_collection: "\n ຄຳຖາມສອບເສັງທີ່ປາກົດໃນອະດີດ",
any_application_registration: "ການລົງທະບຽນຄໍາຮ້ອງສະຫມັກຕ່າງໆ",
mypage_visa_application: "ວີຊາວິຊາສະເພາະ\nໃບສະໝັກ",
applyt_exam_and_agent: "ຄໍາຮ້ອງສະຫມັກການສອບເສັງ\nຄໍາຮ້ອງສະຫມັກບໍລິການຕົວແທນ",
myapge_regist_accept_certificate: "ການທົດສອບສີມື\nການລົງທະບຽນຜ່ານ",
mypage_consultaion_service: "ປຶກສາການຮຽນຮູ້\nບໍລິການ",
consult: "ປຶກສາ",
of_exam_day: "ວັນທີທົດສອບ",
your_ave_score: "ຄະແນນສະເລ່ຍສໍາລັບການທົດສອບ \n ຂອງທ່ານ",
your_estimated_pass_rate: "\n ອັດຕາການຜ່ານໂດຍປະມານຂອງທ່ານ",
your_ave_score_fotter: "ຄະແນນສະເລ່ຍສໍາລັບການທົດສອບຂອງທ່ານ",
your_estimated_pass_rate_fotter: "ອັດຕາການຜ່ານໂດຍປະມານ",
mypage_study_text: "ດາວໂຫລດປື້ມຮຽນ\n",
exam_schedule: "ຕາຕະລາງການສອບເສັງ",
resident_caption_title: "● ກ່ຽວກັບການອັບໂຫຼດບັດທີ່ຢູ່ອາໄສ ຫຼື ບັດປະຈໍາຕົວ",
resident_caption: "ກະລຸນາອັບໂຫລດບັດທີ່ຢູ່ອາໄສ ຫຼືບັດປະຈໍາຕົວທີ່ສາມາດຢືນຢັນຂໍ້ມູນໃນກອບສີແດງ. \nກະລຸນາອັບໂຫຼດບັດທີ່ຢູ່ອາໄສ ຫຼື ບັດປະຈຳຕົວທີ່ຖືກຕ້ອງທີ່ຍັງບໍ່ທັນໝົດອາຍຸ. \nອັບໂຫຼດຮູບສີໃນຮູບແບບ PDF ຫຼື JPG.",
password_caption_title: "● ກ່ຽວກັບການອັບໂຫລດລະຫັດຜ່ານ",
password_caption: "ກະລຸນາອັບໂຫຼດຮູບໜັງສືຜ່ານແດນທີ່ຢືນຢັນຊື່/ຮູບ/ໝາຍເລກສະເພາະ/ວັນເດືອນປີເກີດ/ສັນຊາດ/ວັນໝົດອາຍຸ ດັ່ງທີ່ສະແດງຢູ່ໃນຂອບສີແດງ. \nກະລຸນາອັບໂຫຼດໜັງສືຜ່ານແດນທີ່ຖືກຕ້ອງທີ່ຍັງບໍ່ທັນໝົດອາຍຸ. \nອັບໂຫຼດຮູບສີໃນຮູບແບບ PDF ຫຼື JPG.",
title_help: "ຊ່ວຍເຫຼືອ",
step3_title_help: "ກະລຸນາໃສ່ຂໍ້ມູນຂອງທ່ານຢ່າງຖືກຕ້ອງ.",
lineid_input_help: "ເປີດ LINE → Home → Settings → Profile → ເລື່ອນເຂົ້າໄປເບິ່ງ ID. ກະລຸນາໃສ່ ID ນັ້ນ. ຖ້າທ່ານຍັງບໍ່ໄດ້ສ້າງມັນ, ກະລຸນາສ້າງມັນແລະໃສ່ມັນ.",
country_input_help: "ກະລຸນາເລືອກປະເທດຂອງສັນຊາດຂອງເຈົ້າ.",
area_input_help: "ເລືອກປະເທດຂອງພື້ນທີ່ຂອງທ່ານທີ່ທ່ານອາໄສຢູ່ໃນປະຈຸບັນ.",
phone_input_help: "ກະລຸນາໃສ່ເບີໂທລະສັບຂອງທ່ານ.",
issuing_input_help: "ກະລຸນາເລືອກພື້ນທີ່ທີ່ມີການອອກບັດປະຈຳຕົວຂອງທ່ານ.",
idtype_input_help: "ກະລຸນາເລືອກປະເພດ ID. ກະລຸນາຖ່າຍຮູບທີ່ສວຍງາມຂອງຄົນທີ່ເລືອກແລ້ວອັບໂຫລດມັນ. ກະລຸນາຍິງຊື່ເພື່ອບໍ່ໃຫ້ມີເສັ້ນຂວາງ ຫຼືຈຸດຕັດ.",
invitation_input_help: "ຖ້າທ່ານມີລະຫັດເຊີນ, ໃສ່ມັນ.",
exam_menu_help: "ຈະມີຄຳຖາມທີ່ຄ້າຍຄືກັບຄຳຖາມທີ່ເຄີຍຖາມໃນອະດີດ. ແກ້​ໄຂ​ຄໍາ​ຖາມ​ທີ່​ຊ​້​ໍາ​ເພື່ອ​ກະ​ກຽມ​ສໍາ​ລັບ​ການ​ສອບ​ເສັງ​ໄດ້​.",
past_menu_help: "ທ່ານຈະມີບັນຫາທີ່ທ່ານໄດ້ແກ້ໄຂໃນອະດີດ. ຂໍໃຫ້ທົບທວນຄືນຄວາມຜິດພາດ.",
pastexam_menu_help: "ນີ້ແມ່ນຂໍ້ຄວາມຂອງຄໍາຖາມສອບເສັງທີ່ມີຕົວຈິງໃນອະດີດ.",
text_menu_help: "ເຈົ້າສາມາດເບິ່ງປື້ມແບບຮຽນເພື່ອສຶກສາຈຸດສໍາຄັນແລະຊອກຫາສິ່ງທີ່ເຈົ້າບໍ່ເຂົ້າໃຈ.",
visa_menu_help: "ພວກເຮົາຈະຊ່ວຍໃຫ້ທ່ານໄດ້ຮັບວີຊາທັກສະສະເພາະ. ຖ້າທ່ານຕ້ອງການຂໍວີຊາສໍາລັບທັກສະສະເພາະ, ກະລຸນາສະຫມັກທີ່ນີ້.",
agency_menu_help: "ພວກເຮົາຈະສະຫມັກຂໍການທົດສອບຄວາມສາມາດສະເພາະໃນນາມຂອງທ່ານ. ຖ້າທ່ານຕ້ອງການສອບເສັງທັກສະສະເພາະ, ກະລຸນາສະໝັກທີ່ນີ້.",
cer_menu_help: "ຖ້າທ່ານໄດ້ສອບເສັງວິຊາສະເພາະແລະມີໃບຢັ້ງຢືນຜ່ານ, ກະລຸນາລົງທະບຽນທີ່ນີ້.",
service_menu_help: "ຖ້າ​ຫາກ​ທ່ານ​ມີ​ຄໍາ​ຖາມ​ຫຼື​ຄວາມ​ກັງ​ວົນ​, ກະ​ລຸ​ນາ​ຕິດ​ຕໍ່​ຫາ​ພວກ​ເຮົາ​ໂດຍ​ການ​ສົນ​ທະ​ນາ​ທີ່​ນີ້​.",
occu_title_help: "ກະລຸນາເລືອກເຖິງ 3 ອາຊີບທີ່ຕ້ອງການ.",
back: "ກັບຄືນ",
before: "ກັບບັນຫາທີ່ຜ່ານມາ",
srilank: "ສີ​ລັງ​ກາ",
reselect: "ຖ້າທ່ານຕ້ອງການປ່ຽນໄຟລ໌, ໃຫ້ກົດ &quot;ອັບໂຫຼດຫນັງສືຜ່ານແດນຂອງເຈົ້າ&quot; ອີກເທື່ອຫນຶ່ງແລະເລືອກອີກເທື່ອຫນຶ່ງ",
iphone_file: "ສໍາລັບ iPhone, ກະລຸນາໃຊ້ຫຼັງຈາກປ່ຽນຈາກໄຟລ໌ HEIC ເປັນໄຟລ໌ JPG.",
file_transmit: "ແປງໄຟລ໌",
combodia: 'combodia',
}
